import aokana from '../../assets/thumbnails/aokana.jpg';
import aokana_extra1 from '../../assets/thumbnails/aokana_extra1.jpg';
import aokana_extra2 from '../../assets/thumbnails/aokana_extra2.jpg';
import haretaka from '../../assets/thumbnails/haretaka.jpg';
import konosora from '../../assets/thumbnails/konosora.jpg';
import konosora_fd from '../../assets/thumbnails/konosora_fd.jpg';
import chrono_clock from '../../assets/thumbnails/chrono-clock.jpg';
import maitetsu from '../../assets/thumbnails/maitetsu.jpg';
import da_capo from '../../assets/thumbnails/da-capo.jpg';
import dcif from '../../assets/thumbnails/dcif.jpg';
import kotori_love_exp from '../../assets/thumbnails/kotori_love_exp.jpg';
import da_capo2 from '../../assets/thumbnails/da_capo2.jpg';
import da_capo3 from '../../assets/thumbnails/da_capo3.jpg';
import yoakena from '../../assets/thumbnails/yoakena.jpg';
import dal_segno from '../../assets/thumbnails/dal-segno.jpg';
import hello_good_bye from '../../assets/thumbnails/hello-good-bye.jpg';
import nine_ep1 from '../../assets/thumbnails/nine_ep1.jpg';
import nine_ep2 from '../../assets/thumbnails/nine_ep2.jpg';
import nine_ep3 from '../../assets/thumbnails/nine_ep3.jpg';
import nine_ep4 from '../../assets/thumbnails/nine_ep4.jpg';
import nine_shinshou from '../../assets/thumbnails/nine_shinshou.jpg';
import kinkoi from '../../assets/thumbnails/kinkoi.jpg';
import kinkoi_gt from '../../assets/thumbnails/kinkoi_gt.jpg';
import hoshimemo from '../../assets/thumbnails/hoshimemo.jpg';
import hoshimemo_eh from '../../assets/thumbnails/hoshimemo_eh.jpg';
import daitoshokan from '../../assets/thumbnails/daitoshokan.jpg';
import tamayura_mirai from '../../assets/thumbnails/tamayura_mirai.jpg';
import sakusaku from '../../assets/thumbnails/sakusaku.jpg';
import miazora from '../../assets/thumbnails/miazora.jpg';
import miazora_fd from '../../assets/thumbnails/miazora_fd.jpg';
import koichoco from '../../assets/thumbnails/koichoco.jpg';
import koiken_otome from '../../assets/thumbnails/koiken-otome.jpg';
import corona_blossom from '../../assets/thumbnails/corona-blossom.jpg';
import hitotsuba from '../../assets/thumbnails/hitotsuba.jpg';
import date_a_live from '../../assets/thumbnails/date-a-live.jpg';
import sanoba_witch from '../../assets/thumbnails/sanoba-witch.jpg';
import princess_evangile from '../../assets/thumbnails/princess-evangile.jpg';
import princess_evangile_wh from '../../assets/thumbnails/princess_evangile_wh.jpg';
import koirizo from '../../assets/thumbnails/koirizo.jpg';
import hatsukoi from '../../assets/thumbnails/hatsukoi.jpg';
import cafe_stella from '../../assets/thumbnails/cafe-stella.jpg';
import senren_banka from '../../assets/thumbnails/senren-banka.jpg';
import riddle_joker from '../../assets/thumbnails/riddle-joker.jpg';
import hinatabokko from '../../assets/thumbnails/hinatabokko.jpg';
import canvas_2 from '../../assets/thumbnails/canvas-2.jpg';
import period from '../../assets/thumbnails/period.jpg';
import koi_ama from '../../assets/thumbnails/koi-ama.jpg';
import koi_ama_2 from '../../assets/thumbnails/koi-ama-2.jpg';
import to_heart_2 from '../../assets/thumbnails/to-heart-2.jpg';
import loca_love from '../../assets/thumbnails/loca-love.jpg';
import loca_love_densha from '../../assets/thumbnails/loca_love_densha.jpg';
import loca_love_jinja from '../../assets/thumbnails/loca_love_jinja.jpg';
import suki_suki from '../../assets/thumbnails/suki-suki.jpg';
import hoshi_ori from '../../assets/thumbnails/hoshi-ori.jpg';
import yotsunoha from '../../assets/thumbnails/yotsunoha.jpg';
import kimihime from '../../assets/thumbnails/kimihime.jpg';
import amairo_choco from '../../assets/thumbnails/amairo-choco.jpg';
import amairo_choco2 from '../../assets/thumbnails/amairo-choco2.jpg';
import amairo_choco3 from '../../assets/thumbnails/amairo-choco3.jpg';
import island_diary from '../../assets/thumbnails/island-diary.jpg';
import harmoney from '../../assets/thumbnails/harmoney.jpg';
import study_steady from '../../assets/thumbnails/study-steady.jpg';
import icha_x2_study from '../../assets/thumbnails/icha_x2_study.jpg';
import himukai from '../../assets/thumbnails/himukai.jpg';
import knot_fiction from '../../assets/thumbnails/knot-fiction.jpg';
import ninki_seiyuu from '../../assets/thumbnails/ninki-seiyuu.jpg';
import love_sweets from '../../assets/thumbnails/love-sweets.jpg';
import aikagi from '../../assets/thumbnails/aikagi.jpg';
import aikagi_after_days from '../../assets/thumbnails/aikagi_after_days.jpg';
import icing from '../../assets/thumbnails/icing.jpg';
import shuffle from '../../assets/thumbnails/shuffle.jpg';
import really_really from '../../assets/thumbnails/really_really.jpg';
import nekopara_0 from '../../assets/thumbnails/nekopara_0.jpg';
import nekopara_1 from '../../assets/thumbnails/nekopara_1.jpg';
import nekopara_2 from '../../assets/thumbnails/nekopara_2.jpg';
import nekopara_3 from '../../assets/thumbnails/nekopara_3.jpg';
import nekopara_4 from '../../assets/thumbnails/nekopara_4.jpg';
import nekopara_after from '../../assets/thumbnails/nekopara_after.jpg';
import noble_works from '../../assets/thumbnails/noble-works.jpg';
import dracu_riot from '../../assets/thumbnails/dracu-riot.jpg';
import neko_nin from '../../assets/thumbnails/neko_nin.jpg';
import neko_nin_plus_nachi from '../../assets/thumbnails/neko_nin_plus_nachi.jpg';
import neko_nin_plus_saiha from '../../assets/thumbnails/neko_nin_plus_saiha.jpg';
import neko_nin_2 from '../../assets/thumbnails/neko_nin_2.jpg';
import neko_nin_2_plus from '../../assets/thumbnails/neko_nin_2_plus.jpg';
import neko_nin_3 from '../../assets/thumbnails/neko_nin_3.jpg';
import neko_nin_spin from '../../assets/thumbnails/neko_nin_spin.jpg';
import neko_nin_spin_plus from '../../assets/thumbnails/neko_nin_spin_plus.jpg';
import wagahigh from '../../assets/thumbnails/wagahigh.jpg';
import wagahigh_oc from '../../assets/thumbnails/wagahigh_oc.jpg';
import tsujidou from '../../assets/thumbnails/tsujidou.jpg';
import fureraba from '../../assets/thumbnails/fureraba.jpg';
import fureraba_fd from '../../assets/thumbnails/fureraba_fd.jpg';
import making_lovers from '../../assets/thumbnails/making-lovers.jpg';
import making_lovers_after from '../../assets/thumbnails/making_lovers_after.jpg';
import sugar_style from '../../assets/thumbnails/sugar-style.jpg';
import harem_kingdom from '../../assets/thumbnails/harem-kingdom.jpg';
import hajilove from '../../assets/thumbnails/hajilove.jpg';
import primal_hearts from '../../assets/thumbnails/primal-hearts.jpg';
import primal_hearts_2 from '../../assets/thumbnails/primal_hearts_2.jpg';
import mml from '../../assets/thumbnails/mml.jpg';
import damekoi from '../../assets/thumbnails/damekoi.jpg';
import onikiss from '../../assets/thumbnails/onikiss.jpg';
import onigyu from '../../assets/thumbnails/onigyu.jpg';
import ixshetell from '../../assets/thumbnails/ixshetell.jpg';
import amatarasu_riddle from '../../assets/thumbnails/amatarasu-riddle.jpg';
import ninnin_days from '../../assets/thumbnails/ninnin-days.jpg';
import ninnin_days_2 from '../../assets/thumbnails/ninnin_days_2.jpg';
import troubledays from '../../assets/thumbnails/troubledays.jpg';
import kukkoro_days from '../../assets/thumbnails/kukkoro-days.jpg';
import karakara from '../../assets/thumbnails/karakara.jpg';
import karakara_2 from '../../assets/thumbnails/karakara_2.jpg';
import nekomiko from '../../assets/thumbnails/nekomiko.jpg';
import yuki_koi_melt from '../../assets/thumbnails/yuki-koi-melt.jpg';
import sextet_1 from '../../assets/thumbnails/sextet_1.jpg';
import sextet_2 from '../../assets/thumbnails/sextet_2.jpg';
import sextet_3 from '../../assets/thumbnails/sextet_3.jpg';
import mashimaro from '../../assets/thumbnails/mashimaro.jpg';
import kamiyaba from '../../assets/thumbnails/kamiyaba.jpg';
import otome_domain from '../../assets/thumbnails/otome-domain.jpg';
import idoldays from '../../assets/thumbnails/idoldays.jpg';
import pet_jijou from '../../assets/thumbnails/pet-jijou.jpg';
import pet_jijou_2 from '../../assets/thumbnails/pet-jijou_2.jpg';
import yukizakura from '../../assets/thumbnails/yukizakura.jpg';
import osadai from '../../assets/thumbnails/osadai.jpg';
import osadai_fd from '../../assets/thumbnails/osadai_fd.jpg';
import ikikoi from '../../assets/thumbnails/ikikoi.jpg';
import majikoi from '../../assets/thumbnails/majikoi.jpg';
import majikoi_s from '../../assets/thumbnails/majikoi_s.jpg';
import majikoi_a1 from '../../assets/thumbnails/majikoi_a1.jpg';
import majikoi_a2 from '../../assets/thumbnails/majikoi_a2.jpg';
import majikoi_a3 from '../../assets/thumbnails/majikoi_a3.jpg';
import majikoi_a4 from '../../assets/thumbnails/majikoi_a4.jpg';
import sakura_sakura from '../../assets/thumbnails/sakura-sakura.jpg';
import sankaku_renai from '../../assets/thumbnails/sankaku-renai.jpg';
import koikari from '../../assets/thumbnails/koikari.jpg';
import koikari_fds from '../../assets/thumbnails/koikari_fds.jpg';
import futamata_renai from '../../assets/thumbnails/futamata_renai.jpg';
import onigokko from '../../assets/thumbnails/onigokko.jpg';
import onigokko_fd from '../../assets/thumbnails/onigokko_fd.jpg';
import noratoto from '../../assets/thumbnails/noratoto.jpg';
import noratoto_2 from '../../assets/thumbnails/noratoto_2.jpg';
import drapri from '../../assets/thumbnails/drapri.jpg';
import drapri_plus from '../../assets/thumbnails/drapri_plus.jpg';
import drapri_2 from '../../assets/thumbnails/drapri_2.jpg';
import drapri_3 from '../../assets/thumbnails/drapri_3.jpg';
import kemonomichi from '../../assets/thumbnails/kemonomichi.jpg';
import renai_royale from '../../assets/thumbnails/renai-royale.jpg';
import lovekami from '../../assets/thumbnails/lovekami.jpg';
import lovekami_trouble from '../../assets/thumbnails/lovekami_trouble.jpg';
import koi_iro_chu from '../../assets/thumbnails/koi-iro-chu.jpg';
import momoiro_closet from '../../assets/thumbnails/momoiro-closet.jpg';
import koikuma from '../../assets/thumbnails/koikuma.jpg';
import koikuma_fd from '../../assets/thumbnails/koikuma_fd.jpg';
import kanojo_no_seiiki from '../../assets/thumbnails/kanojo-no-seiiki.jpg';
import uchi_no_kanojo from '../../assets/thumbnails/uchi-no-kanojo.jpg';
import uchi_no_imouto from '../../assets/thumbnails/uchi_no_imouto.jpg';
import uchi_no_koibito from '../../assets/thumbnails/uchi_no_koibito.jpg';
import tenkiame from '../../assets/thumbnails/tenkiame.jpg';
import wabisabi from '../../assets/thumbnails/wabisabi.jpg';
import nyan_cafe from '../../assets/thumbnails/nyan-cafe.jpg';
import wan_nyan from '../../assets/thumbnails/wan-nyan.jpg';
import honey from '../../assets/thumbnails/honey.jpg';
import oneyuu from '../../assets/thumbnails/oneyuu.jpg';
import shugaten from '../../assets/thumbnails/shugaten.jpg';
import mamiya_mami from '../../assets/thumbnails/mamiya-mami.jpg';
import giniro_haruka from '../../assets/thumbnails/giniro-haruka.jpg';
import clover_days from '../../assets/thumbnails/clover-days.jpg';
import walkure_romanze from '../../assets/thumbnails/walkure-romanze.jpg';
import aonatsu_line from '../../assets/thumbnails/aonatsu-line.jpg';
import orefukahi from '../../assets/thumbnails/orefukahi.jpg';
import lover_able from '../../assets/thumbnails/lover-able.jpg';
import majikoi_a5 from '../../assets/thumbnails/majikoi_a5.jpg';
import nursery_rhyme from '../../assets/thumbnails/nursery-rhyme.jpg';
import ponkowa from '../../assets/thumbnails/ponkowa.jpg';
import tenshi_souzou from '../../assets/thumbnails/tenshi-souzou.jpg';
import secret_agent from '../../assets/thumbnails/secret-agent.jpg';
import flowlove from '../../assets/thumbnails/flowlove.jpg';
import kakenuke from '../../assets/thumbnails/kakenuke.jpg';
import renai_royale_fd from '../../assets/thumbnails/renai-royale-fd.jpg';
import baka_moe_heart from '../../assets/thumbnails/baka-moe-heart.jpg';
import enking from '../../assets/thumbnails/enking.jpg';
import melty_moment from '../../assets/thumbnails/melty-moment.jpg';
import iroseka from '../../assets/thumbnails/iroseka.jpg';
import irohika from '../../assets/thumbnails/irohika.jpg';
import akaseka from '../../assets/thumbnails/akaseka.jpg';
import imouto_no_seiiki from '../../assets/thumbnails/imouto-no-seiiki.jpg';
import gakkou_no_seiiki from '../../assets/thumbnails/gakkou-no-seiiki.jpg';
import hoshikaka from '../../assets/thumbnails/hoshikaka.jpg';
import akasaka from '../../assets/thumbnails/akasaka.jpg';
import yumeiro from '../../assets/thumbnails/yumeiro.jpg';
import chiikano from '../../assets/thumbnails/chiikano.jpg';
import hamidashi from '../../assets/thumbnails/hamidashi.jpg';
import raspberry_cube from '../../assets/thumbnails/raspberry-cube.jpg';
import kemonomichi_love_plus from '../../assets/thumbnails/kemonomichi_love_plus.jpg';
import kemonomichi_2 from '../../assets/thumbnails/kemonomichi_2.jpg';
import konosora_snow from '../../assets/thumbnails/konosora_snow.jpg';
import naka_no_hito from '../../assets/thumbnails/naka_no_hito.jpg';
import yomegami from '../../assets/thumbnails/yomegami.jpg';
import shukusei_gf from '../../assets/thumbnails/shukusei_gf.jpg';
import shukusei_gf_2 from '../../assets/thumbnails/shukusei_gf_2.jpg';
import shukusei_gf_3 from '../../assets/thumbnails/shukusei_gf_3.jpg';
import mashiro from '../../assets/thumbnails/mashiro.jpg';
import mashiro_sana from '../../assets/thumbnails/mashiro_sana.jpg';
import amanatsu from '../../assets/thumbnails/amanatsu.jpg';
import amanatsu_plus from '../../assets/thumbnails/amanatsu_plus.jpg';
import happiness_2 from '../../assets/thumbnails/happiness_2.jpg';
import lovepical from '../../assets/thumbnails/lovepical.jpg';
import tayutama from '../../assets/thumbnails/tayutama.jpg';
import tayutama_fd from '../../assets/thumbnails/tayutama_fd.jpg';
import renzero from '../../assets/thumbnails/renzero.jpg';
import golden_marriage from '../../assets/thumbnails/golden_marriage.jpg';
import toheart from '../../assets/thumbnails/toheart.jpg';
import e_school_life from '../../assets/thumbnails/e_school_life.jpg';
import karenai_sekai from '../../assets/thumbnails/karenai_sekai.jpg';
import karigurashi from '../../assets/thumbnails/karigurashi.jpg';
import docchi from '../../assets/thumbnails/docchi.jpg';
import secret_love from '../../assets/thumbnails/secret_love.jpg';
import tenpure from '../../assets/thumbnails/tenpure.jpg';
import triple_pairing from '../../assets/thumbnails/triple_pairing.jpg';
import koikata from '../../assets/thumbnails/koikata.jpg';
import koiama from '../../assets/thumbnails/koiama.jpg';
import yubisaki from '../../assets/thumbnails/yubisaki.jpg';
import imoten from '../../assets/thumbnails/imoten.jpg';
import dora_con_cafe from '../../assets/thumbnails/dora_con_cafe.jpg';
import flyable_heart from '../../assets/thumbnails/flyable_heart.jpg';
import to_heart from '../../assets/thumbnails/to_heart.jpg';
import tsuriotsu from '../../assets/thumbnails/tsuriotsu.jpg';
import tsukikana from '../../assets/thumbnails/tsukikana.jpg';
import monkeys from '../../assets/thumbnails/monkeys.jpg';


import { FilterAttribute, GenreFocus } from './utils';
import { PlaytimeLength } from './utils';

export interface VisualNovelProps {
    //Name of VN. Can use abbreviations when appropriate.
    name: string;
    //Link to VNDB page.
    vndbLink: string;
    //Playtime length, refer to the utils.ts file in this same folder to see options.
    playtime?: PlaytimeLength;
    //Image variable that was imported above.
    thumbnailSource: string;
    //List of attributes the VN may have. Refer to the utils.ts file.
    attributes: FilterAttribute[];
    //Optional. List of VNDB links of sequels if this game has any.
    sequels?: string[];
    //Optional. VNDB link to the first game, if this entry is a sequel/FD.
    originalGame?: string;
    //Genre, refer to utils.ts file.
    genreFocus: GenreFocus;
    //Free form description. Use a few key words to describe the game.
    descriptionFirstRowText: string;
    //Additional description line for more text.
    descriptionSecondRowText: string;
    //Optional. TL's release date.
    translationReleaseDate?: number;
    //Optional. 'true' if the game isn't TL'd yet.
    isUpcomingRelease?: boolean;
    //Optional. This will be dictated by chartanon, pinkfag, or /vn/ as a whole. Don't try to be funny and sneak this in for a vn you like.
    isRecommended?: boolean;
    //Optional. This is for the popup that appears when you want to see more information about a recommended VN.
    recommendedDescription?: string;
}

/**
 * REMEMBER TO UPDATE THE DATE!!!
 */
export const lastUpdatedDate: string = '2026-08-07';

export const visualNovelData: VisualNovelProps[] = [
    {
        name: 'Aokana',
        vndbLink: 'https://vndb.org/v12849',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: aokana,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        sequels: ['https://vndb.org/v20228', 'https://vndb.org/v21438'],
        genreFocus: GenreFocus.STORYLINE,
        descriptionFirstRowText: 'Group of Friends, Sports',
        descriptionSecondRowText: 'Competition',
        translationReleaseDate: Date.parse('2019-09-27'),
        isRecommended: true,
        recommendedDescription: `
                Talent good. Sprite is a company with very high production
                value, which you can see in Aokana's art, OST, and story
                writing. This game has a strong emphasis on its sports-based
                story, however there are still lots of moments of cute girls
                being cute.
                `
    },
    {
        name: 'Aokana EXTRA1',
        vndbLink: 'https://vndb.org/v20228',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: aokana_extra1,
        attributes: [FilterAttribute.ADV_TEXTBOX, FilterAttribute.LINEAR_PLOT],
        originalGame: 'https://vndb.org/v12849',
        genreFocus: GenreFocus.STORYLINE, //TODO Romance?
        descriptionFirstRowText: 'Group of Friends, Pure Love',
        descriptionSecondRowText: 'Single Heroine',
        translationReleaseDate: Date.parse('2020-11-06')
    },
    {
        name: 'Aokana EXTRA2',
        vndbLink: 'https://vndb.org/v21438',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: aokana_extra2,
        attributes: [FilterAttribute.ADV_TEXTBOX, FilterAttribute.LINEAR_PLOT],
        originalGame: 'https://vndb.org/v12849',
        genreFocus: GenreFocus.STORYLINE,
        descriptionFirstRowText: 'Group of Friends, Sports',
        descriptionSecondRowText: 'Competition',
        translationReleaseDate: Date.parse('2022-12-16')
    },
    {
        name: 'Haretaka',
        vndbLink: 'https://vndb.org/v15077',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: haretaka,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.TRUE_ROUTE
        ],
        genreFocus: GenreFocus.STORYLINE,
        descriptionFirstRowText: 'Student Club, Rockets',
        descriptionSecondRowText: 'Design Story',
        translationReleaseDate: Date.parse('2019-09-19')
    },
    {
        name: 'Konosora',
        vndbLink: 'https://vndb.org/v9093',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: konosora,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.BRANCHING_PLOT
        ],
        sequels: ['https://vndb.org/v10979'],
        genreFocus: GenreFocus.STORYLINE,
        descriptionFirstRowText: 'Group of Friends, Gliders',
        descriptionSecondRowText: 'Design Story',
        translationReleaseDate: Date.parse('2018-03-23')
    },
    {
        name: 'Konosora FD',
        vndbLink: 'https://vndb.org/v10979',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: konosora_fd,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.BRANCHING_PLOT,
            FilterAttribute.SCENARIO_SELECTION
        ],
        originalGame: 'https://vndb.org/v9093',
        genreFocus: GenreFocus.STORYLINE,
        descriptionFirstRowText: 'Group of Friends, Gliders',
        descriptionSecondRowText: 'Design Story',
        translationReleaseDate: Date.parse('2019-02-27')
    },
    {
        name: 'Konosora Snow Presents',
        vndbLink: 'https://vndb.org/v14812',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: konosora_snow,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.KINETIC_NOVEL
        ],
        originalGame: 'https://vndb.org/v9093',
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Winter, Single Heroine',
        descriptionSecondRowText: 'Slice of Life',
        translationReleaseDate: Date.parse('2024-12-24')
    },
    {
        name: 'Chrono Clock',
        vndbLink: 'https://vndb.org/v16208',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: chrono_clock,
        attributes: [
            FilterAttribute.FLOATING_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.STORYLINE,
        descriptionFirstRowText: 'Slice of Life Comedy, Deities',
        descriptionSecondRowText: 'Time Travel',
        translationReleaseDate: Date.parse('2017-02-28')
    },
    {
        name: 'Maitetsu',
        vndbLink: 'https://vndb.org/v18131',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: maitetsu,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.TRUE_ROUTE
        ],
        genreFocus: GenreFocus.STORYLINE,
        descriptionFirstRowText: 'Countryside, Trains',
        descriptionSecondRowText: 'Steampunk',
        translationReleaseDate: Date.parse('2018-06-29')
    },
    {
        name: 'Da Capo',
        vndbLink: 'https://vndb.org/v264',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: da_capo,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.TRUE_ROUTE
        ],
        sequels: [
            'https://vndb.org/v1708',
            'https://vndb.org/v3537',
            'https://vndb.org/v266',
            'https://vndb.org/v6438'
        ],
        genreFocus: GenreFocus.STORYLINE,
        descriptionFirstRowText: 'Slice of Life, Drama',
        descriptionSecondRowText: 'Fantasy',
        translationReleaseDate: Date.parse('2008-12-25')
    },
    {
        name: 'Da Capo I.F.',
        vndbLink: 'https://vndb.org/v1708',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: dcif,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.TRUE_ROUTE
        ],
        originalGame: 'https://vndb.org/v264', //TODO actually an alternative version
        genreFocus: GenreFocus.STORYLINE,
        descriptionFirstRowText: 'Slice of Life, Drama',
        descriptionSecondRowText: 'Fantasy',
        translationReleaseDate: Date.parse('2011-04-29')
    },
    {
        name: 'Kotori Love Ex P',
        vndbLink: 'https://vndb.org/v3537',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: kotori_love_exp,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.SCENARIO_SELECTION
        ],
        originalGame: 'https://vndb.org/v264',
        genreFocus: GenreFocus.STORYLINE, //TODO Romance?
        descriptionFirstRowText: 'Slice of Life, Wife Heroine',
        descriptionSecondRowText: 'Fantasy',
        translationReleaseDate: Date.parse('2011-04-29')
    },
    {
        name: 'Da Capo II',
        vndbLink: 'https://vndb.org/v266',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: da_capo2,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.TRUE_ROUTE
        ],
        originalGame: 'https://vndb.org/v264',
        genreFocus: GenreFocus.STORYLINE,
        descriptionFirstRowText: 'Group of Friends, Drama',
        descriptionSecondRowText: 'Fantasy',
        translationReleaseDate: Date.parse('2010-12-24')
    },
    {
        name: 'Da Capo III',
        vndbLink: 'https://vndb.org/v6438',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: da_capo3,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.TRUE_ROUTE
        ],
        originalGame: 'https://vndb.org/v264',
        genreFocus: GenreFocus.STORYLINE,
        descriptionFirstRowText: 'Slice of Life, Drama',
        descriptionSecondRowText: 'Magic School',
        translationReleaseDate: Date.parse('2017-01-20')
    },
    {
        name: 'Yoakena',
        vndbLink: 'https://vndb.org/v232',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: yoakena,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.TRUE_ROUTE,
            FilterAttribute.SUITABLE_FOR_12_YEAR_OLD_FRENCH_GIRLS
        ],
        genreFocus: GenreFocus.STORYLINE,
        descriptionFirstRowText: 'Science Fiction, Drama',
        descriptionSecondRowText: 'Lost Technology',
        translationReleaseDate: Date.parse('2016-07-18')
    },
    {
        name: 'D.S. -Dal Segno-',
        vndbLink: 'https://vndb.org/v17742',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: dal_segno,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.TRUE_ROUTE
        ],
        genreFocus: GenreFocus.STORYLINE,
        descriptionFirstRowText: 'Slice of Life, Drama',
        descriptionSecondRowText: 'Science Fiction',
        translationReleaseDate: Date.parse('2017-06-30')
    },
    {
        name: 'Hello,good-bye',
        vndbLink: 'https://vndb.org/v5316',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: hello_good_bye,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.STORYLINE,
        descriptionFirstRowText: 'Politics, Slice of Life',
        descriptionSecondRowText: 'Espionage',
        translationReleaseDate: Date.parse('2019-01-25')
    },
    {
        name: '9-nine-:Episode 1',
        vndbLink: 'https://vndb.org/v19829',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: nine_ep1,
        attributes: [FilterAttribute.ADV_TEXTBOX, FilterAttribute.LINEAR_PLOT],
        sequels: [
            'https://vndb.org/v21668',
            'https://vndb.org/v23740',
            'https://vndb.org/v26523',
            'https://vndb.org/v29724'
        ],
        genreFocus: GenreFocus.STORYLINE,
        descriptionFirstRowText: 'Superpowers, Suspense',
        descriptionSecondRowText: 'Urban Fantasy',
        translationReleaseDate: Date.parse('2019-01-31'),
        isRecommended: true,
        recommendedDescription: `
                Episodic VN, though all entries have been translated at this
                point. Somewhat debateable if this could be considered a moege,
                as there's a good amount of action and mystery in each episode.
                However there is still a noticeable presence of slice-of-life
                moments and romance.
                `
    },
    {
        name: '9-nine-:Episode 2',
        vndbLink: 'https://vndb.org/v21668',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: nine_ep2,
        attributes: [FilterAttribute.ADV_TEXTBOX, FilterAttribute.LINEAR_PLOT],
        originalGame: 'https://vndb.org/v19829',
        genreFocus: GenreFocus.STORYLINE,
        descriptionFirstRowText: 'Superpowers, Suspense',
        descriptionSecondRowText: 'Urban Fantasy',
        translationReleaseDate: Date.parse('2019-08-16')
    },
    {
        name: '9-nine-:Episode 3',
        vndbLink: 'https://vndb.org/v23740',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: nine_ep3,
        attributes: [FilterAttribute.ADV_TEXTBOX, FilterAttribute.LINEAR_PLOT],
        originalGame: 'https://vndb.org/v19829',
        genreFocus: GenreFocus.STORYLINE,
        descriptionFirstRowText: 'Superpowers, Suspense',
        descriptionSecondRowText: 'Urban Fantasy',
        translationReleaseDate: Date.parse('2020-08-31')
    },
    {
        name: '9-nine-:Episode 4',
        vndbLink: 'https://vndb.org/v26523',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: nine_ep4,
        attributes: [FilterAttribute.ADV_TEXTBOX, FilterAttribute.LINEAR_PLOT],
        originalGame: 'https://vndb.org/v19829',
        genreFocus: GenreFocus.STORYLINE,
        descriptionFirstRowText: 'Superpowers, Suspense',
        descriptionSecondRowText: 'Urban Fantasy',
        translationReleaseDate: Date.parse('2021-03-19')
    },
    {
        name: '9-nine-:Shinshou',
        vndbLink: 'https://vndb.org/v29724',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: nine_shinshou,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.SCENARIO_SELECTION,
            FilterAttribute.SUITABLE_FOR_12_YEAR_OLD_FRENCH_GIRLS
        ],
        originalGame: 'https://vndb.org/v19829',
        genreFocus: GenreFocus.STORYLINE,
        descriptionFirstRowText: 'Superpowers, Suspense',
        descriptionSecondRowText: 'Urban Fantasy',
        translationReleaseDate: Date.parse('2022-03-18')
    },
    {
        name: 'Irotoridori no Sekai',
        vndbLink: 'https://vndb.org/v5834',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: iroseka,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.TRUE_ROUTE
        ],
        sequels: ['https://vndb.org/v10028', 'https://vndb.org/v17147'],
        genreFocus: GenreFocus.STORYLINE,
        descriptionFirstRowText: 'Fantasy, Central Heroine',
        descriptionSecondRowText: 'Alternate Dimensions',
        translationReleaseDate: Date.parse('2024-02-16')
    },
    {
        name: 'Irotoridori no Hikari',
        vndbLink: 'https://vndb.org/v10028',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: irohika,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.SCENARIO_SELECTION,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.TRUE_ROUTE
        ],
        originalGame: 'https://vndb.org/v5834',
        genreFocus: GenreFocus.STORYLINE,
        descriptionFirstRowText: 'Fantasy, Central Heroine',
        descriptionSecondRowText: 'Alternate Dimensions',
        translationReleaseDate: Date.parse('2025-04-02')
    },
    {
        name: 'Akai Hitomi ni Utsuru Sekai',
        vndbLink: 'https://vndb.org/v17147',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: akaseka,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.KINETIC_NOVEL
        ],
        originalGame: 'https://vndb.org/v5834',
        genreFocus: GenreFocus.STORYLINE,
        descriptionFirstRowText: 'Fantasy, Single Heroine',
        descriptionSecondRowText: 'Alternate Dimensions',
        translationReleaseDate: Date.parse('2025-07-23')
    },
    {
        name: 'Tayutama',
        vndbLink: 'https://vndb.org/v828',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: tayutama,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        sequels: ['https://vndb.org/v1375'],
        genreFocus: GenreFocus.STORYLINE,
        descriptionFirstRowText: 'Deities, Shinto Shrine',
        descriptionSecondRowText: 'Dousei',
        translationReleaseDate: Date.parse('2025-03-27')
    },
    {
        name: "Tayutama -It's Happy Days-",
        vndbLink: 'https://vndb.org/v1375',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: tayutama_fd,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        originalGame: 'https://vndb.org/v828',
        genreFocus: GenreFocus.STORYLINE,
        descriptionFirstRowText: 'Deities, Shinto Shrine',
        descriptionSecondRowText: 'Dousei',
        translationReleaseDate: Date.parse('2025-10-23')
    },
    {
        name: 'Karenai Sekai to Owaru Hana',
        vndbLink: 'https://vndb.org/v19658',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: karenai_sekai,
        attributes: [FilterAttribute.ADV_TEXTBOX, FilterAttribute.LINEAR_PLOT],
        genreFocus: GenreFocus.STORYLINE,
        descriptionFirstRowText: 'Cafe, Angels',
        descriptionSecondRowText: 'Nakige',
        translationReleaseDate: Date.parse('2024-09-14')
    },
    {
        name: 'Kinkoi',
        vndbLink: 'https://vndb.org/v21852',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: kinkoi,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.SCENARIO_SELECTION
        ],
        sequels: ['https://vndb.org/v24717'],
        genreFocus: GenreFocus.STORY_ROMANCE,
        descriptionFirstRowText: 'Blondes, School Life Comedy',
        descriptionSecondRowText: 'Reunion',
        translationReleaseDate: Date.parse('2021-06-11')
    },
    {
        name: 'Kinkoi GT',
        vndbLink: 'https://vndb.org/v24717',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: kinkoi_gt,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.SCENARIO_SELECTION
        ],
        originalGame: 'https://vndb.org/v21852',
        genreFocus: GenreFocus.STORY_ROMANCE,
        descriptionFirstRowText: 'Blondes, School Life Comedy',
        descriptionSecondRowText: 'Reunion',
        translationReleaseDate: Date.parse('2022-07-15')
    },
    {
        name: 'Kakenuke',
        vndbLink: 'https://vndb.org/v28286',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: kakenuke,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Summer, School Life Comedy',
        descriptionSecondRowText: 'Student Club',
        translationReleaseDate: Date.parse('2024-10-18')
    },
    {
        name: 'Walkure Romanze',
        vndbLink: 'https://vndb.org/v4041',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: walkure_romanze,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.STORY_ROMANCE,
        descriptionFirstRowText: 'Jousting, Knight Heroines',
        descriptionSecondRowText: 'Coach Protagonist',
        translationReleaseDate: Date.parse('2023-08-18')
    },
    {
        name: 'Hoshimemo',
        vndbLink: 'https://vndb.org/v1474',
        playtime: PlaytimeLength.VERY_LONG,
        thumbnailSource: hoshimemo,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.TRUE_ROUTE
        ],
        sequels: ['https://vndb.org/v2959'],
        genreFocus: GenreFocus.STORY_ROMANCE,
        descriptionFirstRowText: 'School Life Comedy, Drama',
        descriptionSecondRowText: 'Supernatural',
        translationReleaseDate: Date.parse('2012-03-31')
    },
    {
        name: 'Hoshimemo EH',
        vndbLink: 'https://vndb.org/v2959',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: hoshimemo_eh,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.SCENARIO_SELECTION
        ],
        originalGame: 'https://vndb.org/v1474',
        genreFocus: GenreFocus.STORY_ROMANCE,
        descriptionFirstRowText: 'School Life Comedy, Drama',
        descriptionSecondRowText: 'Supernatural',
        translationReleaseDate: Date.parse('2022-11-18')
    },
    {
        name: 'Daitoshokan',
        vndbLink: 'https://vndb.org/v8158',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: daitoshokan,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.STORY_ROMANCE,
        descriptionFirstRowText: 'Urban Fantasy, Mystery',
        descriptionSecondRowText: 'Library Club',
        translationReleaseDate: Date.parse('2019-03-23'),
        isRecommended: true,
        recommendedDescription: `
                For those interested in a good plot, Daitoshokan is a good game
                to start off with. There's a stronger focus on the main
                character's development compared to other moege, and the mystery
                in the story is something you can be invested in. There is still
                a good amount of romance, but the focus is shifted away from it.
                `
    },
    {
        name: 'Tamayura Mirai',
        vndbLink: 'https://vndb.org/v23501',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: tamayura_mirai,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.STORY_ROMANCE,
        descriptionFirstRowText: 'Fantasy, Mythology',
        descriptionSecondRowText: 'Witch Heroine',
        translationReleaseDate: Date.parse('2023-05-12')
    },
    {
        name: 'SakuSaku',
        vndbLink: 'https://vndb.org/v10304',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: sakusaku,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.STORY_ROMANCE,
        descriptionFirstRowText: 'Shinigami, Slice of Life',
        descriptionSecondRowText: 'Supernatural',
        translationReleaseDate: Date.parse('2017-10-02')
    },
    {
        name: 'Miazora',
        vndbLink: 'https://vndb.org/v16560',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: miazora,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT,
            FilterAttribute.SUITABLE_FOR_12_YEAR_OLD_FRENCH_GIRLS
        ],
        sequels: ['https://vndb.org/v18907'],
        genreFocus: GenreFocus.STORY_ROMANCE,
        descriptionFirstRowText: 'Slice of Life, Drama',
        descriptionSecondRowText: 'Astronomy Club',
        translationReleaseDate: Date.parse('2017-12-15')
    },
    {
        name: 'Miazora Fine Days',
        vndbLink: 'https://vndb.org/v18907',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: miazora_fd,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.SCENARIO_SELECTION,
            FilterAttribute.SUITABLE_FOR_12_YEAR_OLD_FRENCH_GIRLS
        ],
        originalGame: 'https://vndb.org/v16560',
        genreFocus: GenreFocus.STORY_ROMANCE,
        descriptionFirstRowText: 'Slice of Life, Drama',
        descriptionSecondRowText: 'Astronomy Club',
        translationReleaseDate: Date.parse('2020-08-22')
    },
    {
        name: 'Koichoco',
        vndbLink: 'https://vndb.org/v4028',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: koichoco,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.STORY_ROMANCE,
        descriptionFirstRowText: 'Friendship, Student Club',
        descriptionSecondRowText: 'Central Heroine',
        translationReleaseDate: Date.parse('2015-11-30')
    },
    {
        name: 'Koiken Otome',
        vndbLink: 'https://vndb.org/v10608',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: koiken_otome,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.STORY_ROMANCE,
        descriptionFirstRowText: 'Group of Friends, Action',
        descriptionSecondRowText: 'Superpowers',
        translationReleaseDate: Date.parse('2016-07-13')
    },
    {
        name: 'Corona Blossom',
        vndbLink: 'https://vndb.org/v19125',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: corona_blossom,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.KINETIC_NOVEL
        ],
        genreFocus: GenreFocus.STORY_ROMANCE,
        descriptionFirstRowText: 'Slice of Life Comedy, Space',
        descriptionSecondRowText: 'Science Fiction',
        translationReleaseDate: Date.parse('2016-07-21')
    },
    {
        name: 'Hitotsuba',
        vndbLink: 'https://vndb.org/v17827',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: hitotsuba,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.STORY_ROMANCE,
        descriptionFirstRowText: 'Dousei, Warplanes',
        descriptionSecondRowText: 'Competition',
        translationReleaseDate: Date.parse('2019-02-27')
    },
    {
        name: 'Date A Live',
        vndbLink: 'https://vndb.org/v12702',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: date_a_live,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.TRUE_ROUTE,
            FilterAttribute.SUITABLE_FOR_12_YEAR_OLD_FRENCH_GIRLS
        ],
        genreFocus: GenreFocus.STORY_ROMANCE,
        descriptionFirstRowText: 'Dating Sim, Slice of Life',
        descriptionSecondRowText: 'Science Fiction',
        translationReleaseDate: Date.parse('2019-07-23')
    },
    {
        name: 'Secret Agent',
        vndbLink: 'https://vndb.org/v27227',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: secret_agent,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.STORY_ROMANCE,
        descriptionFirstRowText: 'Duel, Secret Identity',
        descriptionSecondRowText: 'Science Fiction',
        translationReleaseDate: Date.parse('2023-09-29')
    },
    {
        name: 'Uchi wa Mou, Enki Dekinai.',
        vndbLink: 'https://vndb.org/v31740',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: enking,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.STORY_ROMANCE,
        descriptionFirstRowText: 'Design Story, 4th Wall Breaking',
        descriptionSecondRowText: 'Eroge Development',
        translationReleaseDate: Date.parse('2026-07-24')
    },
    {
        name: 'Sanoba Witch',
        vndbLink: 'https://vndb.org/v16044',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: sanoba_witch,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Occult Club, Witches',
        descriptionSecondRowText: 'Slice of Life Comedy',
        translationReleaseDate: Date.parse('2018-10-26'),
        isRecommended: true,
        recommendedDescription: `
                Yuzusoft is probably the largest moege developer, and Sanoba
                Witch is a popular entry of theirs (You may spot some of their
                characters hidden on this site!). There's a light supernatural
                element to the story, but it's mainly just window dressing for
                interacting with cute girls. Some routes are more heavily
                focused on their route conflict than others.
                `
    },
    {
        name: 'Princess Evangile',
        vndbLink: 'https://vndb.org/v6710',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: princess_evangile,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        sequels: ['https://vndb.org/v8900'],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'School Dormitory, Drama',
        descriptionSecondRowText: 'All-girls School',
        translationReleaseDate: Date.parse('2015-03-27'),
        isRecommended: true,
        recommendedDescription: `
                A very pure moege, that also contains moments of action and
                drama. The setting is rather unique and the main character is
                somewhat of a power fantasy, being the focus of attention to the
                large cast of heroines. There are lots of characters to enjoy,
                and pretty much all routelets get their time to shine in the
                Fandisc.
                `
    },
    {
        name: 'Princess Evangile WH',
        vndbLink: 'https://vndb.org/v8900',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: princess_evangile_wh,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.SCENARIO_SELECTION
        ],
        originalGame: 'https://vndb.org/v6710',
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'School Dormitory, Drama',
        descriptionSecondRowText: 'All-girls School',
        translationReleaseDate: Date.parse('2017-07-28')
    },
    {
        name: 'Koirizo',
        vndbLink: 'https://vndb.org/v13046',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: koirizo,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Dousei, Slice of Life Comedy',
        descriptionSecondRowText: 'Resort',
        translationReleaseDate: Date.parse('2015-09-19')
    },
    {
        name: 'Hatsukoi 1/1',
        vndbLink: 'https://vndb.org/v9124',
        playtime: PlaytimeLength.VERY_LONG,
        thumbnailSource: hatsukoi,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Student Club, Slice of Life',
        descriptionSecondRowText: 'High School',
        translationReleaseDate: Date.parse('2017-05-06'),
        isRecommended: true,
        recommendedDescription: `
                A deep part of /vn/ culture. This is required reading. It's so
                bad that it eventually becomes enjoyable to read. Unfortunately
                we lost one of the best fan translation teams to this evil
                company.
                `
    },
    {
        name: 'Tenshi☆Souzou',
        vndbLink: 'https://vndb.org/v40520',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: tenshi_souzou,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Diablo MC, Slice of Life',
        descriptionSecondRowText: 'Reincarnation',
        translationReleaseDate: Date.parse('2025-01-24')
    },
    {
        name: 'Cafe Stella',
        vndbLink: 'https://vndb.org/v26414',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: cafe_stella,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Cafe, Slice of Life',
        descriptionSecondRowText: 'Supernatural',
        translationReleaseDate: Date.parse('2022-03-25')
    },
    {
        name: 'Senren Banka',
        vndbLink: 'https://vndb.org/v19073',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: senren_banka,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Rural Japan, Slice of Life',
        descriptionSecondRowText: 'Supernatural',
        translationReleaseDate: Date.parse('2020-02-14')
    },
    {
        name: 'Riddle Joker',
        vndbLink: 'https://vndb.org/v22230',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: riddle_joker,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Secret Identity, Slice of Life',
        descriptionSecondRowText: 'Supernatural',
        translationReleaseDate: Date.parse('2020-12-18'),
        isRecommended: true,
        recommendedDescription: `
                Riddle Joker is a prime example of a modern Yuzusoft moege. The
                setting is somewhat fantastical and the plot is technically
                serious, but it's still a pretty light-hearted VN. Due to the
                consistency of Yuzusoft games, if you've read a few of them and
                haven't enjoyed a single one, this might not be the genre for
                you.
                `
    },
    {
        name: "Gin'iro, Haruka",
        vndbLink: 'https://vndb.org/v18778',
        playtime: PlaytimeLength.VERY_LONG,
        thumbnailSource: giniro_haruka,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Slice of Life, Winter',
        descriptionSecondRowText: 'Pure Love Story',
        translationReleaseDate: Date.parse('2024-04-26')
    },
    {
        name: 'Mashiro-iro Symphony',
        vndbLink: 'https://vndb.org/v1552',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: mashiro,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        sequels: ['https://vndb.org/v37651'],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Slice of Life, Winter',
        descriptionSecondRowText: 'Former All-girls School ',
        translationReleaseDate: Date.parse('2024-05-02')
    },
    {
        name: 'Mashiro-iro Sana',
        vndbLink: 'https://vndb.org/v37651',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: mashiro_sana,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.KINETIC_NOVEL
        ],
        originalGame: 'https://vndb.org/v1552',
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Single Heroine, Winter',
        descriptionSecondRowText: 'Former All-girls School ',
        translationReleaseDate: Date.parse('2024-05-02')
    },
    {
        name: "Clover Day's",
        vndbLink: 'https://vndb.org/v13325',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: clover_days,
        attributes: [
            FilterAttribute.FLOATING_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Twins, Slice of Life',
        descriptionSecondRowText: 'Reunion',
        translationReleaseDate: Date.parse('2023-08-18')
    },
    {
        name: 'Shugaten!',
        vndbLink: 'https://vndb.org/v20196',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: shugaten,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Cafe, Winter',
        descriptionSecondRowText: 'Fairy Tale',
        translationReleaseDate: Date.parse('2023-07-28')
    },
    {
        name: 'Hinatabokko',
        vndbLink: 'https://vndb.org/v898',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: hinatabokko,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Slice of Life, Cafe',
        descriptionSecondRowText: 'University',
        translationReleaseDate: Date.parse('2008-07-10')
    },
    {
        name: 'Canvas 2',
        vndbLink: 'https://vndb.org/v174',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: canvas_2,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Teacher MC, High School',
        descriptionSecondRowText: 'Painting Club',
        translationReleaseDate: Date.parse('2010-10-08')
    },
    {
        name: 'Period',
        vndbLink: 'https://vndb.org/v573',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: period,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Angels, High School',
        descriptionSecondRowText: 'Drama',
        translationReleaseDate: Date.parse('2012-08-13')
    },
    {
        name: 'Koi Ama',
        vndbLink: 'https://vndb.org/v21903',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: koi_ama,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        sequels: ['https://vndb.org/v24626'],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Cafe, Waitresses',
        descriptionSecondRowText: 'Countryside',
        translationReleaseDate: Date.parse('2018-09-07')
    },
    {
        name: 'Koi Ama 2',
        vndbLink: 'https://vndb.org/v24626',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: koi_ama_2,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        originalGame: 'https://vndb.org/v21903',
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Cafe, Waitresses',
        descriptionSecondRowText: 'Countryside',
        translationReleaseDate: Date.parse('2021-03-15')
    },
    {
        name: 'To Heart 2',
        vndbLink: 'https://vndb.org/v20',
        playtime: PlaytimeLength.VERY_LONG,
        thumbnailSource: to_heart_2,
        attributes: [
            FilterAttribute.NVL_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'High School, Drama',
        descriptionSecondRowText: 'Reunion',
        translationReleaseDate: Date.parse('2017-09-26')
    },
    {
        name: 'Loca Love Dousei',
        vndbLink: 'https://vndb.org/v23067',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: loca_love,
        attributes: [FilterAttribute.ADV_TEXTBOX, FilterAttribute.LINEAR_PLOT],
        sequels: ['https://vndb.org/v25690', 'https://vndb.org/v26376'],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Dousei, Destiny',
        descriptionSecondRowText: 'Slice of Life',
        translationReleaseDate: Date.parse('2018-10-26')
    },
    {
        name: 'Loca Love Densha',
        vndbLink: 'https://vndb.org/v25690',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: loca_love_densha,
        attributes: [FilterAttribute.ADV_TEXTBOX, FilterAttribute.LINEAR_PLOT],
        originalGame: 'https://vndb.org/v23067',
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Dousei, Destiny',
        descriptionSecondRowText: 'Slice of Life',
        translationReleaseDate: Date.parse('2019-08-30')
    },
    {
        name: 'Loca Love Jinja',
        vndbLink: 'https://vndb.org/v26376',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: loca_love_jinja,
        attributes: [FilterAttribute.ADV_TEXTBOX, FilterAttribute.LINEAR_PLOT],
        originalGame: 'https://vndb.org/v23067',
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Dousei, Destiny',
        descriptionSecondRowText: 'Slice of Life',
        translationReleaseDate: Date.parse('2020-09-25')
    },
    {
        name: 'SukiSuki',
        vndbLink: 'https://vndb.org/v17376',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: suki_suki,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'School Life Comedy, Fairies',
        descriptionSecondRowText: 'Dating Sim',
        translationReleaseDate: Date.parse('2018-12-13')
    },
    {
        name: 'Hoshi Ori',
        vndbLink: 'https://vndb.org/v14265',
        playtime: PlaytimeLength.VERY_LONG,
        thumbnailSource: hoshi_ori,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Slice of Life, Festival',
        descriptionSecondRowText: 'Passage of Time',
        translationReleaseDate: Date.parse('2019-04-03'),
        isRecommended: true,
        recommendedDescription: `
                This is the same developer who made Hatsukoi 1/1. Hoshi Ori Yume
                Mirai is so bereft of conflict and drama, and the fact that the
                "after-story" for each heroine is about half of their route's
                length, means that you'll either love the slow pacing or utterly
                despise it.
                `
    },
    {
        name: 'Yotsunoha',
        vndbLink: 'https://vndb.org/v566',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: yotsunoha,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Slice of Life, Reunion',
        descriptionSecondRowText: 'Middle School',
        translationReleaseDate: Date.parse('2019-07-13')
    },
    {
        name: 'Kimihime',
        vndbLink: 'https://vndb.org/v5942',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: kimihime,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Secret Identity, Slice of Life',
        descriptionSecondRowText: 'School Life Comedy',
        translationReleaseDate: Date.parse('2019-11-08')
    },
    {
        name: 'Amairo Chocolata',
        vndbLink: 'https://vndb.org/v26581',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: amairo_choco,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        sequels: ['https://vndb.org/v30228'],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Cafe, Slice of Life',
        descriptionSecondRowText: 'Kemonomimi',
        translationReleaseDate: Date.parse('2020-12-22')
    },
    {
        name: 'Amairo Chocolata 2',
        vndbLink: 'https://vndb.org/v30228',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: amairo_choco2,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.BRANCHING_PLOT
        ],
        originalGame: 'https://vndb.org/v26581',
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Cafe, Slice of Life',
        descriptionSecondRowText: 'Kemonomimi',
        translationReleaseDate: Date.parse('2023-06-28')
    },
    {
        name: 'Amairo Chocolata 3',
        vndbLink: 'https://vndb.org/v41339',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: amairo_choco3,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.SCENARIO_SELECTION,
            FilterAttribute.BRANCHING_PLOT
        ],
        originalGame: 'https://vndb.org/v26581',
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Cafe, Slice of Life',
        descriptionSecondRowText: 'Kemonomimi',
        translationReleaseDate: Date.parse('2025-11-10')
    },
    {
        name: 'Island Diary',
        vndbLink: 'https://vndb.org/v21436',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: island_diary,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.LINEAR_PLOT,
            FilterAttribute.KINETIC_NOVEL
        ],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Survival, Slice of Life',
        descriptionSecondRowText: 'Kemonomimi',
        translationReleaseDate: Date.parse('2021-03-19')
    },
    {
        name: 'HarmonEy',
        vndbLink: 'https://vndb.org/v22075',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: harmoney,
        attributes: [FilterAttribute.ADV_TEXTBOX, FilterAttribute.LINEAR_PLOT],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Wife Heroine, Slice of Life',
        descriptionSecondRowText: 'Single Heroine',
        translationReleaseDate: Date.parse('2021-03-15')
    },
    {
        name: 'Study § Steady',
        vndbLink: 'https://vndb.org/v24689',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: study_steady,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        sequels: ['https://vndb.org/v30793'],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Winter, Long H-scenes',
        descriptionSecondRowText: 'Slice of Life',
        translationReleaseDate: Date.parse('2021-06-30')
    },
    {
        name: 'Icha x2 Study',
        vndbLink: 'https://vndb.org/v30793',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: icha_x2_study,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.KINETIC_NOVEL
        ],
        originalGame: 'https://vndb.org/v24689',
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Winter, Long H-scenes',
        descriptionSecondRowText: 'Slice of Life',
        translationReleaseDate: Date.parse('2022-06-17')
    },
    {
        name: 'Himukai Chihiro',
        vndbLink: 'https://vndb.org/v30118',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: himukai,
        attributes: [FilterAttribute.ADV_TEXTBOX, FilterAttribute.LINEAR_PLOT],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Pillow Talk, Reunion',
        descriptionSecondRowText: 'Single Heroine',
        translationReleaseDate: Date.parse('2021-07-21')
    },
    {
        name: 'Knot Fiction!',
        vndbLink: 'https://vndb.org/v24586',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: knot_fiction,
        attributes: [FilterAttribute.ADV_TEXTBOX, FilterAttribute.LINEAR_PLOT],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Wife Heroine, Adult MC',
        descriptionSecondRowText: 'Single Heroine',
        translationReleaseDate: Date.parse('2020-12-19')
    },
    {
        name: 'Ninki Seiyuu',
        vndbLink: 'https://vndb.org/v20148',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: ninki_seiyuu,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Seiyuu Heroine, Dousei',
        descriptionSecondRowText: 'Drama',
        translationReleaseDate: Date.parse('2021-10-08')
    },
    {
        name: 'Love Sweets',
        vndbLink: 'https://vndb.org/v14269',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: love_sweets,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Waitress Heroine, Cafe',
        descriptionSecondRowText: 'Slice of Life Comedy',
        translationReleaseDate: Date.parse('2021-10-28')
    },
    {
        name: 'Aikagi',
        vndbLink: 'https://vndb.org/v20232',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: aikagi,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        sequels: ['https://vndb.org/v22037'],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Winter, Dousei',
        descriptionSecondRowText: 'Single Heroine',
        translationReleaseDate: Date.parse('2021-11-18')
    },
    {
        name: 'Aikagi After Days',
        vndbLink: 'https://vndb.org/v22037',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: aikagi_after_days,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.KINETIC_NOVEL
        ],
        originalGame: 'https://vndb.org/v20232',
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Summer, Slice of Life',
        descriptionSecondRowText: 'Single Heroine',
        translationReleaseDate: Date.parse('2023-08-25')
    },
    {
        name: 'Icing -love coating-',
        vndbLink: 'https://vndb.org/v27367',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: icing,
        attributes: [FilterAttribute.ADV_TEXTBOX, FilterAttribute.LINEAR_PLOT],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Bakery, Wife Heroine',
        descriptionSecondRowText: 'Single Heroine',
        translationReleaseDate: Date.parse('2021-12-03')
    },
    {
        name: 'Chiikano',
        vndbLink: 'https://vndb.org/v11072',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: chiikano,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Cafe, Festival',
        descriptionSecondRowText: 'Donkan Protagonist',
        translationReleaseDate: Date.parse('2025-12-18')
    },
    {
        name: 'Happiness! 2',
        vndbLink: 'https://vndb.org/v22013',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: happiness_2,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT,
            FilterAttribute.UNLOCKABLE_ROUTES
        ],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Magic School, Slice of Life',
        descriptionSecondRowText: 'Cherry Blossom',
        translationReleaseDate: Date.parse('2025-05-30')
    },
    {
        name: 'ToHeart',
        vndbLink: 'https://vndb.org/v30616',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: toheart,
        attributes: [
            FilterAttribute.NVL_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT,
            FilterAttribute.SUITABLE_FOR_12_YEAR_OLD_FRENCH_GIRLS
        ],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: '3D slop, Slice of Life',
        descriptionSecondRowText: 'Spring',
        translationReleaseDate: Date.parse('2025-06-25')
    },
    {
        name: 'Amanatsu',
        vndbLink: 'https://vndb.org/v34848',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: amanatsu,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        sequels: ['https://vndb.org/v47551'],
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Countryside, Summer',
        descriptionSecondRowText: 'Group of Friends',
        translationReleaseDate: Date.parse('2024-05-17')
    },
    {
        name: 'Amanatsu+',
        vndbLink: 'https://vndb.org/v47551',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: amanatsu_plus,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.SCENARIO_SELECTION
        ],
        originalGame: 'https://vndb.org/v34848',
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Countryside, Summer',
        descriptionSecondRowText: 'Group of Friends',
        translationReleaseDate: Date.parse('2026-04-14')
    },
    {
        name: 'SHUFFLE!',
        vndbLink: 'https://vndb.org/v28',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: shuffle,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        sequels: ['https://vndb.org/v202'],
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Gods and Devils, Reunion',
        descriptionSecondRowText: 'School Life Comedy',
        translationReleaseDate: Date.parse('2009-08-15')
    },
    {
        name: 'Really? Really!',
        vndbLink: 'https://vndb.org/v202',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: really_really,
        attributes: [FilterAttribute.ADV_TEXTBOX, FilterAttribute.LINEAR_PLOT],
        originalGame: 'https://vndb.org/v28',
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Gods and Devils, Family',
        descriptionSecondRowText: 'School Life Comedy',
        translationReleaseDate: Date.parse('2014-06-06')
    },
    {
        name: 'Nekopara Vol. 1',
        vndbLink: 'https://vndb.org/v15538',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: nekopara_1,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.KINETIC_NOVEL
        ],
        sequels: [
            'https://vndb.org/v17763',
            'https://vndb.org/v18713',
            'https://vndb.org/v19385',
            'https://vndb.org/v26052',
            'https://vndb.org/v32946'
        ],
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Cafe, Dousei, Polyamory',
        descriptionSecondRowText: 'Catgirls',
        translationReleaseDate: Date.parse('2014-12-29')
    },
    {
        name: 'Nekopara Vol. 0',
        vndbLink: 'https://vndb.org/v17763',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: nekopara_0,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.KINETIC_NOVEL
        ],
        originalGame: 'https://vndb.org/v15538',
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Cafe, Dousei, Polyamory',
        descriptionSecondRowText: 'Catgirls',
        translationReleaseDate: Date.parse('2015-08-16')
    },
    {
        name: 'Nekopara Vol. 2',
        vndbLink: 'https://vndb.org/v18713',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: nekopara_2,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.KINETIC_NOVEL
        ],
        originalGame: 'https://vndb.org/v15538',
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Cafe, Dousei, Polyamory',
        descriptionSecondRowText: 'Catgirls',
        translationReleaseDate: Date.parse('2016-02-19')
    },
    {
        name: 'Nekopara Vol. 3',
        vndbLink: 'https://vndb.org/v19385',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: nekopara_3,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.KINETIC_NOVEL
        ],
        originalGame: 'https://vndb.org/v15538',
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Cafe, Dousei, Polyamory',
        descriptionSecondRowText: 'Catgirls',
        translationReleaseDate: Date.parse('2017-05-25')
    },
    {
        name: 'Nekopara Vol. 4',
        vndbLink: 'https://vndb.org/v26052',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: nekopara_4,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.KINETIC_NOVEL
        ],
        originalGame: 'https://vndb.org/v15538',
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Cafe, Dousei, Polyamory',
        descriptionSecondRowText: 'Catgirls',
        translationReleaseDate: Date.parse('2020-11-26')
    },
    {
        name: 'Nekopara After',
        vndbLink: 'https://vndb.org/v32946',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: nekopara_after,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.KINETIC_NOVEL
        ],
        originalGame: 'https://vndb.org/v15538',
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Cafe, Dousei, Polyamory',
        descriptionSecondRowText: 'Catgirls',
        translationReleaseDate: Date.parse('2025-06-13')
    },
    {
        name: 'Noble ☆ Works',
        vndbLink: 'https://vndb.org/v4806',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: noble_works,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Secret Identity, Dousei',
        descriptionSecondRowText: 'School Life Comedy',
        translationReleaseDate: Date.parse('2015-12-24')
    },
    {
        name: 'DRACU-RIOT!',
        vndbLink: 'https://vndb.org/v8213',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: dracu_riot,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Urban Fantasy, Vampires',
        descriptionSecondRowText: 'Slice of Life Comedy',
        translationReleaseDate: Date.parse('2016-09-30')
    },
    {
        name: 'Shukusei no Girlfriend 1',
        vndbLink: 'https://vndb.org/v22880',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: shukusei_gf,
        attributes: [FilterAttribute.ADV_TEXTBOX, FilterAttribute.LINEAR_PLOT],
        sequels: ['https://vndb.org/v23290', 'https://vndb.org/v23772'],
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Mahou Shoujo, Dousei',
        descriptionSecondRowText: 'Single Heroine',
        translationReleaseDate: Date.parse('2023-12-14')
    },
    {
        name: 'Shukusei no Girlfriend 2',
        vndbLink: 'https://vndb.org/v23290',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: shukusei_gf_2,
        attributes: [FilterAttribute.ADV_TEXTBOX, FilterAttribute.LINEAR_PLOT],
        originalGame: 'https://vndb.org/v22880',
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Mahou Shoujo, Dousei',
        descriptionSecondRowText: 'Single Heroine',
        translationReleaseDate: Date.parse('2024-10-29')
    },
    {
        name: 'Shukusei no Girlfriend 3',
        vndbLink: 'https://vndb.org/v23772',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: shukusei_gf_3,
        attributes: [FilterAttribute.ADV_TEXTBOX, FilterAttribute.LINEAR_PLOT],
        originalGame: 'https://vndb.org/v22880',
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Mahou Shoujo, Dousei',
        descriptionSecondRowText: 'Single Heroine',
        translationReleaseDate: Date.parse('2024-10-29')
    },
    {
        name: 'Neko-nin',
        vndbLink: 'https://vndb.org/v20433',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: neko_nin,
        attributes: [FilterAttribute.ADV_TEXTBOX, FilterAttribute.LINEAR_PLOT],
        sequels: [
            'https://vndb.org/v22105',
            'https://vndb.org/v22106',
            'https://vndb.org/v22282',
            'https://vndb.org/v25673',
            'https://vndb.org/v24872',
            'https://vndb.org/v45381',
            'https://vndb.org/v53385'
        ],
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Fantasy, Catgirls',
        descriptionSecondRowText: 'Polyamory',
        translationReleaseDate: Date.parse('2017-04-21')
    },
    {
        name: 'Neko-nin Nachi Hen',
        vndbLink: 'https://vndb.org/v22105',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: neko_nin_plus_nachi,
        attributes: [FilterAttribute.ADV_TEXTBOX, FilterAttribute.LINEAR_PLOT],
        originalGame: 'https://vndb.org/v20433',
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Fantasy, Catgirls',
        descriptionSecondRowText: 'Single Heroine',
        translationReleaseDate: Date.parse('2017-11-02')
    },
    {
        name: 'Neko-nin Saiha Hen',
        vndbLink: 'https://vndb.org/v22106',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: neko_nin_plus_saiha,
        attributes: [FilterAttribute.ADV_TEXTBOX, FilterAttribute.LINEAR_PLOT],
        originalGame: 'https://vndb.org/v20433',
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Fantasy, Kunoichi',
        descriptionSecondRowText: 'Single Heroine',
        translationReleaseDate: Date.parse('2017-11-17')
    },
    {
        name: 'Neko-nin 2',
        vndbLink: 'https://vndb.org/v22282',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: neko_nin_2,
        attributes: [FilterAttribute.ADV_TEXTBOX, FilterAttribute.LINEAR_PLOT],
        originalGame: 'https://vndb.org/v20433',
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Fantasy, Catgirls',
        descriptionSecondRowText: 'Polyamory',
        translationReleaseDate: Date.parse('2018-04-27')
    },
    {
        name: 'Neko-nin 2 Love Plus',
        vndbLink: 'https://vndb.org/v25673',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: neko_nin_2_plus,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.SCENARIO_SELECTION
        ],
        originalGame: 'https://vndb.org/v20433',
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Fantasy, Catgirls',
        descriptionSecondRowText: 'Polyamory',
        translationReleaseDate: Date.parse('2019-04-26')
    },
    {
        name: 'Neko-nin 3',
        vndbLink: 'https://vndb.org/v24872',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: neko_nin_3,
        attributes: [FilterAttribute.ADV_TEXTBOX, FilterAttribute.LINEAR_PLOT],
        originalGame: 'https://vndb.org/v20433',
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Fantasy, Catgirls',
        descriptionSecondRowText: 'Polyamory',
        translationReleaseDate: Date.parse('2019-10-18')
    },
    {
        name: 'Neko-nin SPIN',
        vndbLink: 'https://vndb.org/v45381',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: neko_nin_spin,
        attributes: [FilterAttribute.ADV_TEXTBOX, FilterAttribute.LINEAR_PLOT],
        originalGame: 'https://vndb.org/v20433',
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Fantasy, Catgirls',
        descriptionSecondRowText: 'Polyamory',
        translationReleaseDate: Date.parse('2024-07-15')
    },
    {
        name: 'Neko-nin SPIN LOVE+PLUS',
        vndbLink: 'https://vndb.org/v53385',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: neko_nin_spin_plus,
        attributes: [FilterAttribute.ADV_TEXTBOX, FilterAttribute.LINEAR_PLOT],
        originalGame: 'https://vndb.org/v20433',
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Fantasy, Catgirls',
        descriptionSecondRowText: 'Polyamory',
        translationReleaseDate: Date.parse('2025-12-15')
    },
    {
        name: 'Wagahigh',
        vndbLink: 'https://vndb.org/v17823',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: wagahigh,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        sequels: ['https://vndb.org/v20524'],
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Slice of Life, Student Club',
        descriptionSecondRowText: 'School Life Comedy',
        translationReleaseDate: Date.parse('2017-07-27'),
        isRecommended: true,
        recommendedDescription: `
                One of the more standard moege entries in this chart. Like the
                title implies, the unique quirk with the heroines of Wagamama
                High Spec is their relatively selfish behaviour. However that's
                not to say that they're dislikeable, they're just more strongly
                opinionated. A good balance of romance and comedy, with just a
                tiny emphasis on it's plot.
                `
    },
    {
        name: 'Wagahigh OC',
        vndbLink: 'https://vndb.org/v20524',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: wagahigh_oc,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.SCENARIO_SELECTION
        ],
        originalGame: 'https://vndb.org/v17823',
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Slice of Life, Student Club',
        descriptionSecondRowText: 'School Life Comedy',
        translationReleaseDate: Date.parse('2026-02-13')
    },
    {
        name: 'Tsujidou',
        vndbLink: 'https://vndb.org/v9879',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: tsujidou,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Central Heroine, Delinquents',
        descriptionSecondRowText: 'Slice of Life Comedy',
        translationReleaseDate: Date.parse('2018-03-19')
    },
    {
        name: 'Fureraba',
        vndbLink: 'https://vndb.org/v11856',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: fureraba,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        sequels: ['https://vndb.org/v15602'],
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Dating Sim, Slice of Life',
        descriptionSecondRowText: 'School Life Comedy',
        translationReleaseDate: Date.parse('2018-03-19'),
        isRecommended: true,
        recommendedDescription: `
                One of the older games here, Fureraba is pretty extreme with
                it's comedy at times, but is also another heavily ichaicha
                focused entry from Smee. The route selection system in this game
                is closer to a dating sim than your normal moege, where you ask
                heroines questions and need to choose the best response.
                `
    },
    {
        name: 'Fureraba Mini FD',
        vndbLink: 'https://vndb.org/v15602',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: fureraba_fd,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.SCENARIO_SELECTION
        ],
        originalGame: 'https://vndb.org/v11856',
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Girlfriend Heroines, Slice of Life',
        descriptionSecondRowText: 'School Life Comedy',
        translationReleaseDate: Date.parse('2019-02-15')
    },
    {
        name: 'Making*Lovers',
        vndbLink: 'https://vndb.org/v21552',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: making_lovers,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        sequels: ['https://vndb.org/v22594'],
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Dating Sim, Adult Life',
        descriptionSecondRowText: 'Slice of Life Comedy',
        translationReleaseDate: Date.parse('2020-04-03'),
        isRecommended: true,
        recommendedDescription: `
                The setting for Making*Lovers is unique compared to most other
                moege, where the main character is a working adult who doesn't
                live with their parents. The common route is very short and you
                get into the process of forming a relationship very quickly.
                There's a fun gimmick of being able to plan where some of the
                dates take place. Great for those that like comedy and ichaicha,
                with this entry leaning a bit more into the latter.
                `
    },
    {
        name: 'Making*Lovers After',
        vndbLink: 'https://vndb.org/v22594',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: making_lovers_after,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.SCENARIO_SELECTION
        ],
        originalGame: 'https://vndb.org/v21552',
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Girlfriend Heroine, Adult Life',
        descriptionSecondRowText: 'Slice of Life Comedy',
        translationReleaseDate: Date.parse('2022-08-26')
    },
    {
        name: 'Sugar*Style',
        vndbLink: 'https://vndb.org/v24320',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: sugar_style,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Dormitory, University',
        descriptionSecondRowText: 'Slice of Life Comedy',
        translationReleaseDate: Date.parse('2021-04-30')
    },
    {
        name: 'Harem Kingdom',
        vndbLink: 'https://vndb.org/v26765',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: harem_kingdom,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Polyamory, Isekai',
        descriptionSecondRowText: 'King Protagonist',
        translationReleaseDate: Date.parse('2021-09-24')
    },
    {
        name: 'LOVEPICAL-POPPY!',
        vndbLink: 'https://vndb.org/v48420',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: lovepical,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Cafe, Dormitory',
        descriptionSecondRowText: 'Slice of Life Comedy',
        translationReleaseDate: Date.parse('2025-12-19')
    },
    {
        name: 'HajiLove',
        vndbLink: 'https://vndb.org/v30456',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: hajilove,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Pure Love, Wedding',
        descriptionSecondRowText: 'Slice of Life Comedy',
        translationReleaseDate: Date.parse('2026-04-11')
    },
    {
        name: 'PRIMAL×HEARTS',
        vndbLink: 'https://vndb.org/v14887',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: primal_hearts,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        sequels: ['https://vndb.org/v17038'],
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Student Council, Politics',
        descriptionSecondRowText: 'Slice of Life Comedy',
        translationReleaseDate: Date.parse('2021-07-30'),
        isRecommended: true,
        recommendedDescription: `
                A gateway to moenukige, for those that are interested. If you
                like this game, there's also the other translated Marmalade
                games (including the sequel). All of them have high production
                quality and a nice art style to look at.
                `
    },
    {
        name: 'PRIMAL×HEARTS 2',
        vndbLink: 'https://vndb.org/v17038',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: primal_hearts_2,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        originalGame: 'https://vndb.org/v14887',
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Student Council, Politics',
        descriptionSecondRowText: 'Slice of Life Comedy',
        translationReleaseDate: Date.parse('2021-07-30')
    },
    {
        name: 'MML',
        vndbLink: 'https://vndb.org/v12559',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: mml,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Childhood Promise, Reunion',
        descriptionSecondRowText: 'Slice of Life Comedy',
        translationReleaseDate: Date.parse('2018-04-26')
    },
    {
        name: 'Damekoi',
        vndbLink: 'https://vndb.org/v415',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: damekoi,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.LADDER_STRUCTURE
        ],
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Love Triangle, Dousei',
        descriptionSecondRowText: 'Central Heroine',
        translationReleaseDate: Date.parse('2019-05-16')
    },
    {
        name: 'Onikiss',
        vndbLink: 'https://vndb.org/v18694',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: onikiss,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Dousei, Imouto, Kissing',
        descriptionSecondRowText: 'Family Life Comedy',
        translationReleaseDate: Date.parse('2019-09-24')
    },
    {
        name: 'Onigyu',
        vndbLink: 'https://vndb.org/v22345',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: onigyu,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Dousei, Imouto, Hugging',
        descriptionSecondRowText: 'Family Life Comedy',
        translationReleaseDate: Date.parse('2025-09-13')
    },
    {
        name: 'IxSHE Tell',
        vndbLink: 'https://vndb.org/v21956',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: ixshetell,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Love Triangle, Deredere',
        descriptionSecondRowText: 'Slice of Life Comedy',
        translationReleaseDate: Date.parse('2020-08-28')
    },
    {
        name: 'E School Life',
        vndbLink: 'https://vndb.org/v24935',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: e_school_life,
        attributes: [
            FilterAttribute.NVL_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Homecoming, Slice of Life',
        descriptionSecondRowText: 'Pure Love Story',
        translationReleaseDate: Date.parse('2025-11-18')
    },
    {
        name: 'Amatarasu',
        vndbLink: 'https://vndb.org/v12992',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: amatarasu_riddle,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Magic, Slice of Life, Comedy',
        descriptionSecondRowText: 'Urban Fantasy',
        translationReleaseDate: Date.parse('2019-10-10')
    },
    {
        name: 'NinNinDays',
        vndbLink: 'https://vndb.org/v26310',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: ninnin_days,
        attributes: [FilterAttribute.ADV_TEXTBOX, FilterAttribute.LINEAR_PLOT],
        sequels: [
            'https://vndb.org/v32805',
            'https://vndb.org/v27751',
            'https://vndb.org/v28345',
            'https://vndb.org/v31363'
        ],
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Ninja Heroine, Dousei',
        descriptionSecondRowText: 'Modern Day',
        translationReleaseDate: Date.parse('2019-08-08')
    },
    {
        name: 'NinNinDays 2',
        vndbLink: 'https://vndb.org/v32805',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: ninnin_days_2,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        originalGame: 'https://vndb.org/v26310',
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Ninja Heroine, Dousei',
        descriptionSecondRowText: 'Modern Day',
        translationReleaseDate: Date.parse('2022-01-20')
    },
    {
        name: 'TroubleDays',
        vndbLink: 'https://vndb.org/v27751',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: troubledays,
        attributes: [FilterAttribute.ADV_TEXTBOX, FilterAttribute.LINEAR_PLOT],
        originalGame: 'https://vndb.org/v26310',
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Succubus, Modern Days',
        descriptionSecondRowText: 'Single Heroine',
        translationReleaseDate: Date.parse('2020-02-13')
    },
    {
        name: 'KukkoroDays',
        vndbLink: 'https://vndb.org/v28345',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: kukkoro_days,
        attributes: [FilterAttribute.ADV_TEXTBOX, FilterAttribute.LINEAR_PLOT],
        originalGame: 'https://vndb.org/v26310',
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Knight Heroine, Modern Day',
        descriptionSecondRowText: 'Single Heroine',
        translationReleaseDate: Date.parse('2020-05-14')
    },
    {
        name: 'IdolDays',
        vndbLink: 'https://vndb.org/v31363',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: idoldays,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        originalGame: 'https://vndb.org/v26310',
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Idols, Dousei',
        descriptionSecondRowText: 'Single Heroine',
        translationReleaseDate: Date.parse('2021-08-05')
    },
    {
        name: 'NekoMiko',
        vndbLink: 'https://vndb.org/v25170',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: nekomiko,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Catgirls, Polyamory',
        descriptionSecondRowText: 'Shinto Shrine',
        translationReleaseDate: Date.parse('2019-01-24')
    },
    {
        name: 'Isekai Sextet Vol. 1',
        vndbLink: 'https://vndb.org/v29482',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: sextet_1,
        attributes: [FilterAttribute.ADV_TEXTBOX, FilterAttribute.LINEAR_PLOT],
        sequels: ['https://vndb.org/v31090', 'https://vndb.org/v29482'],
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Isekai, Polyamory',
        descriptionSecondRowText: 'Episodic',
        translationReleaseDate: Date.parse('2020-12-14')
    },
    {
        name: 'Isekai Sextet Vol. 2',
        vndbLink: 'https://vndb.org/v31090',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: sextet_2,
        attributes: [FilterAttribute.ADV_TEXTBOX, FilterAttribute.LINEAR_PLOT],
        originalGame: 'https://vndb.org/v29482',
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Isekai, Polyamory',
        descriptionSecondRowText: 'Episodic',
        translationReleaseDate: Date.parse('2021-02-18')
    },
    {
        name: 'Isekai Sextet Vol. 3',
        vndbLink: 'https://vndb.org/v29482',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: sextet_3,
        attributes: [FilterAttribute.ADV_TEXTBOX, FilterAttribute.LINEAR_PLOT],
        originalGame: 'https://vndb.org/v29482',
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Isekai, Polyamory',
        descriptionSecondRowText: 'Episodic',
        translationReleaseDate: Date.parse('2021-05-13')
    },
    {
        name: 'Karakara',
        vndbLink: 'https://vndb.org/v18974',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: karakara,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.KINETIC_NOVEL
        ],
        sequels: ['https://vndb.org/v20980'],
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Dystopia, Kemonomimi',
        descriptionSecondRowText: 'Lost Technology',
        translationReleaseDate: Date.parse('2016-06-27')
    },
    {
        name: 'Karakara 2',
        vndbLink: 'https://vndb.org/v20980',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: karakara_2,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.KINETIC_NOVEL
        ],
        originalGame: 'https://vndb.org/v18974',
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Dystopia, Kemonomimi',
        descriptionSecondRowText: 'Lost Technology',
        translationReleaseDate: Date.parse('2017-11-10')
    },
    {
        name: 'Yuki Koi Melt',
        vndbLink: 'https://vndb.org/v15064',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: yuki_koi_melt,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Winter Club, School Life',
        descriptionSecondRowText: 'Slice of Life Comedy',
        translationReleaseDate: Date.parse('2020-04-29')
    },
    {
        name: 'Mashimaro',
        vndbLink: 'https://vndb.org/v20622',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: mashimaro,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Cafe, Part-time Job',
        descriptionSecondRowText: 'Slice of Life Comedy',
        translationReleaseDate: Date.parse('2022-01-07')
    },
    {
        name: 'Ponkowa',
        vndbLink: 'https://vndb.org/v31002',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: ponkowa,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Cupid Heroine, Dousei',
        descriptionSecondRowText: 'School Life Comedy',
        translationReleaseDate: Date.parse('2023-07-21')
    },
    {
        name: 'Kamiyaba',
        vndbLink: 'https://vndb.org/v19769',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: kamiyaba,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Goddess Heroine, Comedy',
        descriptionSecondRowText: 'Destiny',
        translationReleaseDate: Date.parse('2022-01-21')
    },
    {
        name: 'Otome * Domain',
        vndbLink: 'https://vndb.org/v18149',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: otome_domain,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Trap MC, All-girls School',
        descriptionSecondRowText: 'School Dormitory',
        translationReleaseDate: Date.parse('2022-12-23')
    },
    {
        name: 'Uchi no Pet Jijou',
        vndbLink: 'https://vndb.org/v34004',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: pet_jijou,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.KINETIC_NOVEL
        ],
        sequels: ['https://vndb.org/v63759'],
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Angels and Demons, Dousei',
        descriptionSecondRowText: 'Deredere Heroine',
        translationReleaseDate: Date.parse('2022-04-08')
    },
    {
        name: 'Uchi no Pet Jijou Vol. 2',
        vndbLink: 'https://vndb.org/v63759',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: pet_jijou_2,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.KINETIC_NOVEL
        ],
        originalGame: 'https://vndb.org/v34004',
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Angels and Demons, Dousei',
        descriptionSecondRowText: 'Deredere Heroine',
        translationReleaseDate: Date.parse('2026-06-22')
    },
    {
        name: 'Dora-Con Cafe',
        vndbLink: 'https://vndb.org/v51010',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: dora_con_cafe,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.KINETIC_NOVEL
        ],
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Dragon Heroine, Slice of Life',
        descriptionSecondRowText: 'Under the Same Roof',
        translationReleaseDate: Date.parse('2026-04-23')
    },
    {
        name: 'Yukizakura',
        vndbLink: 'https://vndb.org/v71',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: yukizakura,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.COMEDY,
        descriptionFirstRowText: 'Countryside, Winter',
        descriptionSecondRowText: 'Slice of Life Comedy',
        translationReleaseDate: Date.parse('2007-12-13')
    },
    {
        name: 'Osadai',
        vndbLink: 'https://vndb.org/v2622',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: osadai,
        attributes: [
            FilterAttribute.FLOATING_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        sequels: ['https://vndb.org/v4981'],
        genreFocus: GenreFocus.COMEDY,
        descriptionFirstRowText: 'Science Fiction, Parody',
        descriptionSecondRowText: 'Tongue-in-cheek',
        translationReleaseDate: Date.parse('2011-12-26')
    },
    {
        name: 'Osadai FD',
        vndbLink: 'https://vndb.org/v4981',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: osadai_fd,
        attributes: [
            FilterAttribute.FLOATING_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        originalGame: 'https://vndb.org/v2622',
        genreFocus: GenreFocus.COMEDY,
        descriptionFirstRowText: 'Science Fiction, Parody',
        descriptionSecondRowText: 'Tongue-in-cheek',
        translationReleaseDate: Date.parse('2014-07-04')
    },
    {
        name: 'Ikikoi',
        vndbLink: 'https://vndb.org/v5240',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: ikikoi,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.COMEDY,
        descriptionFirstRowText: 'Slice of life, High School',
        descriptionSecondRowText: 'Slapstick',
        translationReleaseDate: Date.parse('2013-11-24')
    },
    {
        name: 'Majikoi',
        vndbLink: 'https://vndb.org/v1143',
        playtime: PlaytimeLength.VERY_LONG,
        thumbnailSource: majikoi,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.BRANCHING_PLOT
        ],
        sequels: [
            'https://vndb.org/v6245',
            'https://vndb.org/v20598',
            'https://vndb.org/v20599',
            'https://vndb.org/v20600',
            'https://vndb.org/v20601',
            'https://vndb.org/v20602'
        ],
        genreFocus: GenreFocus.COMEDY,
        descriptionFirstRowText: 'Martial Arts, Group of Friends',
        descriptionSecondRowText: 'Slice of Life Comedy',
        translationReleaseDate: Date.parse('2015-03-10'),
        isRecommended: true,
        recommendedDescription: `
                Lots of choices you can make, with a huge cast of characters.
                It's pretty lengthy and has several fandiscs, so there's a lot
                to sink your teeth into if this is something you enjoy. That
                being said, this isn't your typical moege, as there's a bit more
                drama and plot here, as well as having actual fight scenes. If
                the above sounds interesting, go ahead and try it out.
                Otherwise, feel free to check something else out, as this is far
                from the norm for moege.
                `
    },
    {
        name: 'Majikoi S',
        vndbLink: 'https://vndb.org/v6245',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: majikoi_s,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.BRANCHING_PLOT
        ],
        originalGame: 'https://vndb.org/v1143',
        genreFocus: GenreFocus.COMEDY,
        descriptionFirstRowText: 'Martial Arts, Group of Friends',
        descriptionSecondRowText: 'Slice of Life Comedy',
        translationReleaseDate: Date.parse('2015-07-17')
    },
    {
        name: 'Majikoi A-1',
        vndbLink: 'https://vndb.org/v20598',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: majikoi_a1,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.SCENARIO_SELECTION
        ],
        originalGame: 'https://vndb.org/v1143',
        genreFocus: GenreFocus.COMEDY,
        descriptionFirstRowText: 'Martial Arts, Group of Friends',
        descriptionSecondRowText: 'Slice of Life Comedy',
        translationReleaseDate: Date.parse('2016-06-20')
    },
    {
        name: 'Majikoi A-2',
        vndbLink: 'https://vndb.org/v20599',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: majikoi_a2,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.SCENARIO_SELECTION
        ],
        originalGame: 'https://vndb.org/v1143',
        genreFocus: GenreFocus.COMEDY,
        descriptionFirstRowText: 'Martial Arts, Group of Friends',
        descriptionSecondRowText: 'Slice of Life Comedy',
        translationReleaseDate: Date.parse('2016-12-15')
    },
    {
        name: 'Majikoi A-3',
        vndbLink: 'https://vndb.org/v20600',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: majikoi_a3,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.SCENARIO_SELECTION
        ],
        originalGame: 'https://vndb.org/v1143',
        genreFocus: GenreFocus.COMEDY,
        descriptionFirstRowText: 'Martial Arts, Group of Friends',
        descriptionSecondRowText: 'Slice of Life Comedy',
        translationReleaseDate: Date.parse('2020-04-01')
    },
    {
        name: 'Majikoi A-4',
        vndbLink: 'https://vndb.org/v20601',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: majikoi_a4,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.SCENARIO_SELECTION
        ],
        originalGame: 'https://vndb.org/v1143',
        genreFocus: GenreFocus.COMEDY,
        descriptionFirstRowText: 'Martial Arts, Group of Friends',
        descriptionSecondRowText: 'Slice of Life Comedy',
        translationReleaseDate: Date.parse('2021-08-10')
    },
    {
        name: 'Majikoi A-5',
        vndbLink: 'https://vndb.org/v20602',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: majikoi_a5,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.SCENARIO_SELECTION
        ],
        originalGame: 'https://vndb.org/v1143',
        genreFocus: GenreFocus.COMEDY,
        descriptionFirstRowText: 'Martial Arts, Group of Friends',
        descriptionSecondRowText: 'Slice of Life Comedy',
        translationReleaseDate: Date.parse('2023-09-04')
    },
    {
        name: 'Sakura Sakura',
        vndbLink: 'https://vndb.org/v481',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: sakura_sakura,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.COMEDY,
        descriptionFirstRowText: 'Dousei, Slice of Life Comedy',
        descriptionSecondRowText: 'Multiple MCs',
        translationReleaseDate: Date.parse('2018-11-19')
    },
    {
        name: "Sankaku Ren'ai",
        vndbLink: 'https://vndb.org/v19444',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: sankaku_renai,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.COMEDY,
        descriptionFirstRowText: 'Slice of Life, Group of Friends',
        descriptionSecondRowText: 'Comedic Love Triangle',
        translationReleaseDate: Date.parse('2019-05-31')
    },
    {
        name: "Ren'ai 0 Kilometer",
        vndbLink: 'https://vndb.org/v6714',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: renzero,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.COMEDY,
        descriptionFirstRowText: 'Family Life, Comedy',
        descriptionSecondRowText: 'Breaking the Fourth Wall',
        translationReleaseDate: Date.parse('2026-01-29')
    },
    {
        name: "Karigurashi Ren'ai",
        vndbLink: 'https://vndb.org/v22045',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: karigurashi,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.COMEDY,
        descriptionFirstRowText: 'Homecoming, Comedy',
        descriptionSecondRowText: 'Under the Same Roof',
        translationReleaseDate: Date.parse('2026-03-26')
    },
    {
        name: 'Koikari',
        vndbLink: 'https://vndb.org/v25366',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: koikari,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        sequels: ['https://vndb.org/v26418'],
        genreFocus: GenreFocus.COMEDY,
        descriptionFirstRowText: 'Love Triangle, Comedy',
        descriptionSecondRowText: 'Rent-a-boyfriend',
        translationReleaseDate: Date.parse('2021-10-22'),
        isRecommended: true,
        recommendedDescription: `
                The most popular ASa Project game on /vn/, this company is
                generally known for some pretty over the top comedy and fourth
                wall breaks. The story is rather silly and not meant to be taken
                seriously, with the focus being on the heroines themselves.
                `
    },
    {
        name: 'Koikari FDs',
        vndbLink: 'https://vndb.org/v26418',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: koikari_fds,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.SCENARIO_SELECTION
        ],
        originalGame: 'https://vndb.org/v25366',
        genreFocus: GenreFocus.COMEDY,
        descriptionFirstRowText: 'Love Triangle, Comedy',
        descriptionSecondRowText: 'Rent-a-boyfriend',
        translationReleaseDate: Date.parse('2025-10-31')
    },
    {
        name: "Ren'ai x Royale",
        vndbLink: 'https://vndb.org/v28633',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: renai_royale,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.COMEDY,
        descriptionFirstRowText: 'Comedy, 4th Wall Breaking',
        descriptionSecondRowText: 'Love Triangle',
        translationReleaseDate: Date.parse('2022-09-30')
    },
    {
        name: "Futamata Ren'ai",
        vndbLink: 'https://vndb.org/v32811',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: futamata_renai,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.COMEDY,
        descriptionFirstRowText: 'Comedy, Infidelity',
        descriptionSecondRowText: 'Love Triangle',
        translationReleaseDate: Date.parse('2025-07-26')
    },
    {
        name: 'Onigokko!',
        vndbLink: 'https://vndb.org/v5549',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: onigokko,
        attributes: [
            FilterAttribute.FLOATING_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.BRANCHING_PLOT
        ],
        sequels: ['https://vndb.org/v7625'],
        genreFocus: GenreFocus.COMEDY,
        descriptionFirstRowText: 'Japanese Mythology, Comedy',
        descriptionSecondRowText: 'Slice of Life',
        translationReleaseDate: Date.parse('2021-06-29')
    },
    {
        name: 'Onigokko! FD',
        vndbLink: 'https://vndb.org/v7625',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: onigokko_fd,
        attributes: [
            FilterAttribute.FLOATING_TEXTBOX,
            FilterAttribute.SCENARIO_SELECTION
        ],
        originalGame: 'https://vndb.org/v5549',
        genreFocus: GenreFocus.COMEDY,
        descriptionFirstRowText: 'Japanese Mythology, Comedy',
        descriptionSecondRowText: 'Slice of Life',
        translationReleaseDate: Date.parse('2023-06-23')
    },
    {
        name: 'Noratoto',
        vndbLink: 'https://vndb.org/v18148',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: noratoto,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT,
            FilterAttribute.SUITABLE_FOR_12_YEAR_OLD_FRENCH_GIRLS
        ],
        sequels: ['https://vndb.org/v19841'],
        genreFocus: GenreFocus.COMEDY,
        descriptionFirstRowText: 'Animorph, Different Worlds',
        descriptionSecondRowText: 'Slice of Life Comedy',
        translationReleaseDate: Date.parse('2019-06-17')
    },
    {
        name: 'Noratoto 2',
        vndbLink: 'https://vndb.org/v19841',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: noratoto_2,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT,
            FilterAttribute.SUITABLE_FOR_12_YEAR_OLD_FRENCH_GIRLS
        ],
        originalGame: 'https://vndb.org/v18148',
        genreFocus: GenreFocus.COMEDY,
        descriptionFirstRowText: 'Animorph, Different Worlds',
        descriptionSecondRowText: 'Slice of Life Comedy',
        translationReleaseDate: Date.parse('2019-11-08')
    },
    {
        name: 'DraPri',
        vndbLink: 'https://vndb.org/v28634',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: drapri,
        attributes: [FilterAttribute.ADV_TEXTBOX, FilterAttribute.LINEAR_PLOT],
        sequels: [
            'https://vndb.org/v30029',
            'https://vndb.org/v30649',
            'https://vndb.org/v37055'
        ],
        genreFocus: GenreFocus.COMEDY,
        descriptionFirstRowText: 'Dragons, Love Triangle',
        descriptionSecondRowText: 'Slice of Life Comedy',
        translationReleaseDate: Date.parse('2021-01-29')
    },
    {
        name: 'DraPri Love Plus',
        vndbLink: 'https://vndb.org/v30029',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: drapri_plus,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.SCENARIO_SELECTION
        ],
        originalGame: 'https://vndb.org/v28634',
        genreFocus: GenreFocus.COMEDY,
        descriptionFirstRowText: 'Dragons, Love Triangle',
        descriptionSecondRowText: 'Slice of Life Comedy',
        translationReleaseDate: Date.parse('2021-06-22')
    },
    {
        name: 'DraPri 2',
        vndbLink: 'https://vndb.org/v30649',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: drapri_2,
        attributes: [FilterAttribute.ADV_TEXTBOX, FilterAttribute.LINEAR_PLOT],
        originalGame: 'https://vndb.org/v28634',
        genreFocus: GenreFocus.COMEDY,
        descriptionFirstRowText: 'Dragons, Love Triangle',
        descriptionSecondRowText: 'Slice of Life Comedy',
        translationReleaseDate: Date.parse('2021-12-17')
    },
    {
        name: 'DraPri 3',
        vndbLink: 'https://vndb.org/v37055',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: drapri_3,
        attributes: [FilterAttribute.ADV_TEXTBOX, FilterAttribute.LINEAR_PLOT],
        originalGame: 'https://vndb.org/v28634',
        genreFocus: GenreFocus.COMEDY,
        descriptionFirstRowText: 'Dragons, Love Triangle',
        descriptionSecondRowText: 'Slice of Life Comedy',
        translationReleaseDate: Date.parse('2023-03-14')
    },
    {
        name: 'Kemonomichi',
        vndbLink: 'https://vndb.org/v31669',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: kemonomichi,
        attributes: [FilterAttribute.ADV_TEXTBOX, FilterAttribute.LINEAR_PLOT],
        sequels: ['https://vndb.org/v36773', 'https://vndb.org/v40507'],
        genreFocus: GenreFocus.COMEDY,
        descriptionFirstRowText: 'Mahou Shoujo, Idols',
        descriptionSecondRowText: 'Slice of Life Comedy',
        translationReleaseDate: Date.parse('2022-08-12')
    },
    {
        name: 'Kemonomichi L+P',
        vndbLink: 'https://vndb.org/v36773',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: kemonomichi_love_plus,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.KINETIC_NOVEL
        ],
        originalGame: 'https://vndb.org/v31669',
        genreFocus: GenreFocus.COMEDY,
        descriptionFirstRowText: 'Mahou Shoujo, Idols',
        descriptionSecondRowText: 'Slice of Life Comedy',
        translationReleaseDate: Date.parse('2023-11-17')
    },
    {
        name: 'Kemonomichi 2',
        vndbLink: 'https://vndb.org/v40507',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: kemonomichi_2,
        attributes: [FilterAttribute.ADV_TEXTBOX, FilterAttribute.LINEAR_PLOT],
        originalGame: 'https://vndb.org/v31669',
        genreFocus: GenreFocus.COMEDY,
        descriptionFirstRowText: 'Mahou Shoujo, Idols',
        descriptionSecondRowText: 'Slice of Life Comedy',
        translationReleaseDate: Date.parse('2023-12-18')
    },
    {
        name: 'Lovekami',
        vndbLink: 'https://vndb.org/v20337',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: lovekami,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT,
            FilterAttribute.SUITABLE_FOR_12_YEAR_OLD_FRENCH_GIRLS
        ],
        sequels: ['https://vndb.org/v21188'],
        genreFocus: GenreFocus.COMEDY,
        descriptionFirstRowText: 'Goddesses, Slice of Life',
        descriptionSecondRowText: 'Comedic Love Triangle',
        translationReleaseDate: Date.parse('2017-10-27')
    },
    {
        name: 'Lovekami FD',
        vndbLink: 'https://vndb.org/v21188',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: lovekami_trouble,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT,
            FilterAttribute.SUITABLE_FOR_12_YEAR_OLD_FRENCH_GIRLS
        ],
        originalGame: 'https://vndb.org/v20337',
        genreFocus: GenreFocus.COMEDY,
        descriptionFirstRowText: 'Goddesses, Slice of Life',
        descriptionSecondRowText: 'Comedic Love Triangle',
        translationReleaseDate: Date.parse('2017-05-29')
    },
    {
        name: 'Koiiro Chu! Lips',
        vndbLink: 'https://vndb.org/v4017',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: koi_iro_chu,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.COMEDY,
        descriptionFirstRowText: 'Cupids, Supernatural',
        descriptionSecondRowText: 'Student Life Comedy',
        translationReleaseDate: Date.parse('2014-06-21')
    },
    {
        name: 'Yomegami',
        vndbLink: 'https://vndb.org/v19686',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: yomegami,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.COMEDY,
        descriptionFirstRowText: 'Magic/ESP, Love Triangle',
        descriptionSecondRowText: 'Slice of Life Comedy',
        translationReleaseDate: Date.parse('2025-08-29')
    },
    {
        name: 'Tenpure!!',
        vndbLink: 'https://vndb.org/v22357',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: tenpure,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.COMEDY,
        descriptionFirstRowText: 'Clichés, High School',
        descriptionSecondRowText: 'School Life Comedy',
        translationReleaseDate: Date.parse('2026-06-26')
    },
    {
        name: 'Mamiya Mami',
        vndbLink: 'https://vndb.org/v33130',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: mamiya_mami,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.KINETIC_NOVEL
        ],
        genreFocus: GenreFocus.NUKIGE,
        descriptionFirstRowText: 'Succubus Heroine, Dormitory',
        descriptionSecondRowText: 'Supernatural ',
        translationReleaseDate: Date.parse('2023-12-01')
    },
    {
        name: 'Momoiro Closet',
        vndbLink: 'https://vndb.org/v21458',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: momoiro_closet,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.NUKIGE,
        descriptionFirstRowText: 'Otaku, Slice of Life',
        descriptionSecondRowText: 'Cosplay',
        translationReleaseDate: Date.parse('2018-04-27')
    },
    {
        name: 'Koikuma',
        vndbLink: 'https://vndb.org/v17515',
        playtime: PlaytimeLength.LONG,
        thumbnailSource: koikuma,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.BRANCHING_PLOT
        ],
        sequels: ['https://vndb.org/v18791'],
        genreFocus: GenreFocus.NUKIGE,
        descriptionFirstRowText: 'Dousei, Slice of Life Comedy',
        descriptionSecondRowText: 'Demons',
        translationReleaseDate: Date.parse('2018-10-26')
    },
    {
        name: 'Koikuma Suggoi Ecchi!',
        vndbLink: 'https://vndb.org/v18791',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: koikuma_fd,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.UNLOCKABLE_ROUTES,
            FilterAttribute.SCENARIO_SELECTION
        ],
        originalGame: 'https://vndb.org/v17515',
        genreFocus: GenreFocus.NUKIGE,
        descriptionFirstRowText: 'Dousei, Slice of Life Comedy',
        descriptionSecondRowText: 'Demons',
        translationReleaseDate: Date.parse('2020-12-15')
    },
    {
        name: 'Kanojo no Seiiki',
        vndbLink: 'https://vndb.org/v16150',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: kanojo_no_seiiki,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        sequels: ['https://vndb.org/v16845', 'https://vndb.org/v19302'],
        genreFocus: GenreFocus.NUKIGE,
        descriptionFirstRowText: 'Master and Servant, Comedy',
        descriptionSecondRowText: 'Single Heroine',
        translationReleaseDate: Date.parse('2023-03-13')
    },
    {
        name: 'Imouto no Seiiki',
        vndbLink: 'https://vndb.org/v16845',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: imouto_no_seiiki,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        originalGame: 'https://vndb.org/v16150',
        genreFocus: GenreFocus.NUKIGE,
        descriptionFirstRowText: 'Brocon Heroine, Domicile',
        descriptionSecondRowText: 'Single Heroine',
        translationReleaseDate: Date.parse('2023-06-26')
    },
    {
        name: 'Gakkou no Seiiki',
        vndbLink: 'https://vndb.org/v19302',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: gakkou_no_seiiki,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        originalGame: 'https://vndb.org/v16150',
        genreFocus: GenreFocus.NUKIGE,
        descriptionFirstRowText: 'Teacher Heroine, Slice of Life',
        descriptionSecondRowText: 'Half-Japanese Heroine',
        translationReleaseDate: Date.parse('2023-12-15')
    },
    {
        name: 'Uchi no Kanojo',
        vndbLink: 'https://vndb.org/v22658',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: uchi_no_kanojo,
        attributes: [FilterAttribute.ADV_TEXTBOX, FilterAttribute.LINEAR_PLOT],
        sequels: ['https://vndb.org/v22725', 'https://vndb.org/v22726'],
        genreFocus: GenreFocus.NUKIGE,
        descriptionFirstRowText: 'Deredere, Dousei',
        descriptionSecondRowText: 'Single Heroine',
        translationReleaseDate: Date.parse('2021-08-26')
    },
    {
        name: 'Uchi no Imouto',
        vndbLink: 'https://vndb.org/v22725',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: uchi_no_imouto,
        attributes: [FilterAttribute.ADV_TEXTBOX, FilterAttribute.LINEAR_PLOT],
        originalGame: 'https://vndb.org/v22658',
        genreFocus: GenreFocus.NUKIGE,
        descriptionFirstRowText: 'Forbidden Love, Dousei',
        descriptionSecondRowText: 'Single Heroine',
        translationReleaseDate: Date.parse('2022-04-28')
    },
    {
        name: 'Uchi no Koibito',
        vndbLink: 'https://vndb.org/v22726',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: uchi_no_koibito,
        attributes: [FilterAttribute.ADV_TEXTBOX, FilterAttribute.LINEAR_PLOT],
        originalGame: 'https://vndb.org/v22658',
        genreFocus: GenreFocus.NUKIGE,
        descriptionFirstRowText: 'Gyaru, Dousei',
        descriptionSecondRowText: 'Threesome',
        translationReleaseDate: Date.parse('2023-05-20')
    },
    {
        name: 'Tenkiame',
        vndbLink: 'https://vndb.org/v17337',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: tenkiame,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.NUKIGE,
        descriptionFirstRowText: 'Countryside, Kitsune',
        descriptionSecondRowText: 'Slice of Life',
        translationReleaseDate: Date.parse('2018-12-26')
    },
    {
        name: 'Wabisabi',
        vndbLink: 'https://vndb.org/v27276',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: wabisabi,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.KINETIC_NOVEL
        ],
        genreFocus: GenreFocus.NUKIGE,
        descriptionFirstRowText: 'Countryside, Kemonomimi',
        descriptionSecondRowText: 'Goddess Heroine',
        translationReleaseDate: Date.parse('2019-12-20')
    },
    {
        name: 'Nyan Café',
        vndbLink: 'https://vndb.org/v12505',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: nyan_cafe,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.NUKIGE,
        descriptionFirstRowText: 'Cat Cafe, Polyamory',
        descriptionSecondRowText: 'Adult Protagonist',
        translationReleaseDate: Date.parse('2020-07-09')
    },
    {
        name: 'Wan Nyan',
        vndbLink: 'https://vndb.org/v17997',
        playtime: PlaytimeLength.MEDIUM,
        thumbnailSource: wan_nyan,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.NUKIGE,
        descriptionFirstRowText: 'Deredere Heroines, Baking',
        descriptionSecondRowText: 'Animal Cafe',
        translationReleaseDate: Date.parse('2020-09-03')
    },
    {
        name: 'Honey*Honey*Honey!',
        vndbLink: 'https://vndb.org/v28834',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: honey,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.NUKIGE,
        descriptionFirstRowText: 'Deredere Heroine, Pillow Talk',
        descriptionSecondRowText: 'Teacher Heroine',
        translationReleaseDate: Date.parse('2021-08-06')
    },
    {
        name: 'Oneyuu',
        vndbLink: 'https://vndb.org/v22483',
        playtime: PlaytimeLength.SHORT,
        thumbnailSource: oneyuu,
        attributes: [
            FilterAttribute.ADV_TEXTBOX,
            FilterAttribute.BRANCHING_PLOT
        ],
        genreFocus: GenreFocus.NUKIGE,
        descriptionFirstRowText: 'Older Sister, Secret Romance',
        descriptionSecondRowText: 'Single Heroine',
        translationReleaseDate: Date.parse('2022-03-31')
    },
    {
        name: 'Koikata',
        vndbLink: 'https://vndb.org/v17632',
        thumbnailSource: koikata,
        attributes: [],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Kagami Games',
        descriptionSecondRowText: '2026-08-25',
        isUpcomingRelease: true
    },
    {
        name: 'Golden Marriage',
        vndbLink: 'https://vndb.org/v14264',
        thumbnailSource: golden_marriage,
        attributes: [],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'NekoNyan',
        descriptionSecondRowText: '2026',
        isUpcomingRelease: true
    },
    {
        name: 'Floral Flowlove',
        vndbLink: 'https://vndb.org/v18842',
        thumbnailSource: flowlove,
        attributes: [],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'NekoNyan',
        descriptionSecondRowText: '2026',
        isUpcomingRelease: true
    },
    {
        name: 'AkaSaka',
        vndbLink: 'https://vndb.org/v547',
        thumbnailSource: akasaka,
        attributes: [],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Sekai Project',
        descriptionSecondRowText: '2026',
        isUpcomingRelease: true
    },
    {
        name: 'Nursery☆Rhyme',
        vndbLink: 'https://vndb.org/v310',
        thumbnailSource: nursery_rhyme,
        attributes: [],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'kawaiinium',
        descriptionSecondRowText: '2027',
        isUpcomingRelease: true
    },
    {
        name: 'Triple Pairing',
        vndbLink: 'https://vndb.org/v61832',
        thumbnailSource: triple_pairing,
        attributes: [],
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Kagami Games',
        descriptionSecondRowText: 'TBA',
        isUpcomingRelease: true
    },
    {
        name: 'Docchi no i ga Suki Desu ka?',
        vndbLink: 'https://vndb.org/v25999',
        thumbnailSource: docchi,
        attributes: [],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'NekoNyan',
        descriptionSecondRowText: 'TBA',
        isUpcomingRelease: true
    },
    {
        name: 'Secret Love',
        vndbLink: 'https://vndb.org/v50153',
        thumbnailSource: secret_love,
        attributes: [],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'NekoNyan',
        descriptionSecondRowText: 'TBA',
        isUpcomingRelease: true
    },
    {
        name: 'KoiAma',
        vndbLink: 'https://vndb.org/v39649',
        thumbnailSource: koiama,
        attributes: [],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'NekoNyan',
        descriptionSecondRowText: 'TBA',
        isUpcomingRelease: true
    },
    {
        name: 'Yubisaki Connection',
        vndbLink: 'https://vndb.org/v29667',
        thumbnailSource: yubisaki,
        attributes: [],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'NekoNyan',
        descriptionSecondRowText: 'TBA',
        isUpcomingRelease: true
    },
    {
        name: 'Imoten',
        vndbLink: 'https://vndb.org/v21495',
        thumbnailSource: imoten,
        attributes: [],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'JAST',
        descriptionSecondRowText: 'TBA',
        isUpcomingRelease: true
    },
    {
        name: 'Aonatsu Line',
        vndbLink: 'https://vndb.org/v24702',
        thumbnailSource: aonatsu_line,
        attributes: [],
        genreFocus: GenreFocus.STORY_ROMANCE,
        descriptionFirstRowText: 'Fan translation',
        descriptionSecondRowText: 'TBA',
        isUpcomingRelease: true
    },
    {
        name: 'Orefukahi',
        vndbLink: 'https://vndb.org/v23388',
        thumbnailSource: orefukahi,
        attributes: [],
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Fan translation',
        descriptionSecondRowText: 'Common route patch released',
        isUpcomingRelease: true
    },
    {
        name: 'Flyable Heart',
        vndbLink: 'https://vndb.org/v1179',
        thumbnailSource: flyable_heart,
        attributes: [],
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'Fan translation',
        descriptionSecondRowText: 'TBA',
        isUpcomingRelease: true
    },
    {
        name: 'To Heart',
        vndbLink: 'https://vndb.org/v18',
        thumbnailSource: to_heart,
        attributes: [],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Fan translation',
        descriptionSecondRowText: 'TBA',
        isUpcomingRelease: true
    },
    {
        name: 'Tsuriotsu',
        vndbLink: 'https://vndb.org/v10680',
        thumbnailSource: tsuriotsu,
        attributes: [],
        genreFocus: GenreFocus.STORY_ROMANCE,
        descriptionFirstRowText: 'Fan translation',
        descriptionSecondRowText: 'TBA',
        isUpcomingRelease: true
    },
    {
        name: 'Tsukikana',
        vndbLink: 'https://vndb.org/v24803',
        thumbnailSource: tsukikana,
        attributes: [],
        genreFocus: GenreFocus.STORY_ROMANCE,
        descriptionFirstRowText: 'Fan translation',
        descriptionSecondRowText: 'TBA',
        isUpcomingRelease: true
    },
    {
        name: 'Monkeys!¡',
        vndbLink: 'https://vndb.org/v31262',
        thumbnailSource: monkeys,
        attributes: [],
        genreFocus: GenreFocus.COMEDY,
        descriptionFirstRowText: 'Shiravune',
        descriptionSecondRowText: 'TBA',
        isUpcomingRelease: true
    },
    {
        name: 'Lover Able',
        vndbLink: 'https://vndb.org/v5734',
        thumbnailSource: lover_able,
        attributes: [],
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'kawaiinium',
        descriptionSecondRowText: 'TBA',
        isUpcomingRelease: true
    },
    {
        name: "Ren'ai x Royale FDs",
        vndbLink: 'https://vndb.org/v30239',
        thumbnailSource: renai_royale_fd,
        attributes: [],
        genreFocus: GenreFocus.COMEDY,
        descriptionFirstRowText: 'NekoNyan',
        descriptionSecondRowText: 'TBA',
        isUpcomingRelease: true
    },
    {
        name: 'Baka Moe Heart',
        vndbLink: 'https://vndb.org/v13651',
        thumbnailSource: baka_moe_heart,
        attributes: [],
        genreFocus: GenreFocus.ROM_COM,
        descriptionFirstRowText: 'NekoNyan',
        descriptionSecondRowText: 'TBA',
        isUpcomingRelease: true
    },
    {
        name: 'MeltyMoment',
        vndbLink: 'https://vndb.org/v12830',
        thumbnailSource: melty_moment,
        attributes: [],
        genreFocus: GenreFocus.STORY_ROMANCE,
        descriptionFirstRowText: 'NekoNyan',
        descriptionSecondRowText: 'TBA',
        isUpcomingRelease: true
    },
    {
        name: 'Hoshikaka',
        vndbLink: 'https://vndb.org/v2968',
        thumbnailSource: hoshikaka,
        attributes: [],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Sekai Project',
        descriptionSecondRowText: 'TBA',
        isUpcomingRelease: true
    },
    {
        name: 'Yumeiro',
        vndbLink: 'https://vndb.org/v16516',
        thumbnailSource: yumeiro,
        attributes: [],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Sekai Project',
        descriptionSecondRowText: 'TBA',
        isUpcomingRelease: true
    },
    {
        name: 'Hamidashi Creative',
        vndbLink: 'https://vndb.org/v27449',
        thumbnailSource: hamidashi,
        attributes: [],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Sekai Project',
        descriptionSecondRowText: 'TBA',
        isUpcomingRelease: true
    },
    {
        name: 'Raspberry Cube',
        vndbLink: 'https://vndb.org/v22847',
        thumbnailSource: raspberry_cube,
        attributes: [],
        genreFocus: GenreFocus.ROMANCE,
        descriptionFirstRowText: 'Sekai Project',
        descriptionSecondRowText: 'TBA',
        isUpcomingRelease: true
    },
    {
        name: 'Naka no Hito nado Inai!',
        vndbLink: 'https://vndb.org/v10237',
        thumbnailSource: naka_no_hito,
        attributes: [],
        genreFocus: GenreFocus.COMEDY,
        descriptionFirstRowText: 'JAST',
        descriptionSecondRowText: 'TBA',
        isUpcomingRelease: true
    }
];
